(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[95405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(12807);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 12807:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Index": function() { return /* binding */ Index; },
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./components/_stores/tooltip-store.tsx
var tooltip_store = __webpack_require__(34909);
// EXTERNAL MODULE: ./components/image.tsx + 1 modules
var components_image = __webpack_require__(13195);
;// CONCATENATED MODULE: ./public/images/about/dont-be-a-dick.jpg
/* harmony default export */ var dont_be_a_dick = ({"src":"/_next/static/media/dont-be-a-dick.99716ff8.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAACAgMAAwAAAAAAAAAAAAABAgAEAwURIUGR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAZEQACAwEAAAAAAAAAAAAAAAABEQACcQP/2gAMAwEAAhEDEQA/AIW9HY11DHjyWEzrVCuwYHrdYAjvfnj3ERJbhLI/OxL2f//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/profile-lionshead.jpg
/* harmony default export */ var profile_lionshead = ({"src":"/_next/static/media/profile-lionshead.076cc3c4.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABAwQDAAAAAAAAAAAAAAACAAEDBAURYQYSMf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAaEQACAwEBAAAAAAAAAAAAAAABAgADEZEh/9oADAMBAAIRAxEAPwCG48wuZhBFUztUxGTn1kiH1nxjbaRESU6UB09g3Ipb0Dk//9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/namibia.jpg
/* harmony default export */ var namibia = ({"src":"/_next/static/media/namibia.57e70ca2.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDBQQSFCFhof/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAaEQACAgMAAAAAAAAAAAAAAAAAEwECA1FS/9oADAMBAAIRAxEAPwC/Jc2TcVs26aBINQAgbx14iIguydC1U1B//9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/quadbike.jpg
/* harmony default export */ var quadbike = ({"src":"/_next/static/media/quadbike.1c758398.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAdEAABBAIDAAAAAAAAAAAAAAABAAMEEQIFEmGh/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EABgRAAMBAQAAAAAAAAAAAAAAAAECEQAi/9oADAMBAAIRAxEAPwCnb72RC37jjYsR2g2GrrA8xYyPd+IiISKCoua/Mm//2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/alpha-backpack.jpg
/* harmony default export */ var alpha_backpack = ({"src":"/_next/static/media/alpha-backpack.a7d20416.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAEFAAAAAAAAAAAAAAACAAEDEQQGEiFhgf/EABUBAQEAAAAAAAAAAAAAAAAAAAIE/8QAGhEAAgMBAQAAAAAAAAAAAAAAAQIAAwQhBf/aAAwDAQACEQMRAD8Ak5BuOqI8V2uCUoxcbrdfF9eIiJW+hqqChHPRJ3xZ2PVE/9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/christmas-wilderness.jpg
/* harmony default export */ var christmas_wilderness = ({"src":"/_next/static/media/christmas-wilderness.84ff3f00.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAfEAABAwMFAAAAAAAAAAAAAAACAAEDBBEhBQYSE5H/xAAVAQEBAAAAAAAAAAAAAAAAAAABA//EABkRAAMAAwAAAAAAAAAAAAAAAAABEQIDIf/aAAwDAQACEQMRAD8Aqpt9a0QHPJ0vDFcHj45J2ze/qIipr7aOSUR//9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/ottertrail.jpg
/* harmony default export */ var ottertrail = ({"src":"/_next/static/media/ottertrail.f8ba59f6.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAP/xAAdEAACAgEFAAAAAAAAAAAAAAABAwASAgQGEUFx/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EABgRAAIDAAAAAAAAAAAAAAAAAAACASIx/9oADAMBAAIRAxEAPwC+k3Kxj7XIXyTQIxHXsREY8WCph//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/running.jpg
/* harmony default export */ var running = ({"src":"/_next/static/media/running.3b30a9a6.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAgEAABAwIHAAAAAAAAAAAAAAACAAEDESEEBQYSMWGB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwX/xAAZEQACAwEAAAAAAAAAAAAAAAABAgADETH/2gAMAwEAAhEDEQA/AKtP5YBTQ4ONygqInvjN3vyz0fy3SIinWKCdMd0XeT//2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/restaurant.jpg
/* harmony default export */ var restaurant = ({"src":"/_next/static/media/restaurant.46742e56.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABAwUBAAAAAAAAAAAAAAABAAIDBBESEyEG/8QAFAEBAAAAAAAAAAAAAAAAAAAABf/EABgRAAMBAQAAAAAAAAAAAAAAAAECAwAx/9oADAMBAAIRAxEAPwCJL42nhdNvdvcGWByxsSOHgRERM7OR3KPJAeb/2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/restaurant-diy.jpg
/* harmony default export */ var restaurant_diy = ({"src":"/_next/static/media/restaurant-diy.28de5f58.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABAwQDAAAAAAAAAAAAAAABAAIRAwQFEhMhIv/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAXEQEBAQEAAAAAAAAAAAAAAAABAgAh/9oADAMBAAIRAxEAPwCfFXjLzGVrRzOM6gAtkz6kydge4AREQXaUhmmRO7//2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/wedding.jpg
/* harmony default export */ var wedding = ({"src":"/_next/static/media/wedding.8c7b4e0b.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABBAIDAQAAAAAAAAAAAAAEAAECEQMhEzEykf/EABUBAQEAAAAAAAAAAAAAAAAAAAME/8QAGhEAAgIDAAAAAAAAAAAAAAAAAAECESExQf/aAAwDAQACEQMRAD8AhLJKCxAk882y54vK4yfdNe779N8REUM4pVjgb2f/2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/alpha-mountain.jpg
/* harmony default export */ var alpha_mountain = ({"src":"/_next/static/media/alpha-mountain.2b31be45.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABBAIDAQAAAAAAAAAAAAABAAIDBQQREiGBkf/EABQBAQAAAAAAAAAAAAAAAAAAAAT/xAAZEQACAwEAAAAAAAAAAAAAAAABAwACMVH/2gAMAwEAAhEDEQA/AKaLPsrW0mwM+wmBZHx3D0C5utn0H6iIi2awHYgrpyf/2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/kirstenbosch.jpg
/* harmony default export */ var kirstenbosch = ({"src":"/_next/static/media/kirstenbosch.1930c320.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAT/xAAeEAABBAEFAAAAAAAAAAAAAAABAAIDBREEBhITkf/EABQBAQAAAAAAAAAAAAAAAAAAAAP/xAAYEQADAQEAAAAAAAAAAAAAAAAAAQISIf/aAAwDAQACEQMRAD8Amrd03dAzrh1xfGOIMb2hwGcAY9RES4l9YU00j//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/camping.jpg
/* harmony default export */ var camping = ({"src":"/_next/static/media/camping.1120733f.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAdEAABBAMBAQAAAAAAAAAAAAACAAMEEQEhQSKB/8QAFAEBAAAAAAAAAAAAAAAAAAAAAv/EABcRAQADAAAAAAAAAAAAAAAAAAEAAxH/2gAMAwEAAhEDEQA/AJwQHJpug5LdCi8ZHOwrt9vd/EREbAEyGoMZ/9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/great-ideas.jpg
/* harmony default export */ var great_ideas = ({"src":"/_next/static/media/great-ideas.4d7189e0.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAABAwMFAAAAAAAAAAAAAAAAAQIDBBESBRQiIzH/xAAVAQEBAAAAAAAAAAAAAAAAAAACBP/EABsRAAIBBQAAAAAAAAAAAAAAAAECAAMEERIh/9oADAMBAAIRAxEAPwCkr9U2aRNjy7pMXcUS9/AASNbUtiMRr1QTP//Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/desert.jpg
/* harmony default export */ var desert = ({"src":"/_next/static/media/desert.2e16c428.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAACAgMBAAAAAAAAAAAAAAABAwACESFBUv/EABUBAQEAAAAAAAAAAAAAAAAAAAID/8QAGREAAgMBAAAAAAAAAAAAAAAAAAMBE1IU/9oADAMBAAIRAxEAPwC2asKrewSg+c1J53cREn0N1I6F5P/Z","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./public/images/about/profile-adelphi.jpg
/* harmony default export */ var profile_adelphi = ({"src":"/_next/static/media/profile-adelphi.6d136734.jpg","height":1500,"width":2000,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAfEAACAgAHAQAAAAAAAAAAAAABAgAEAwUGEhMUQWH/xAAUAQEAAAAAAAAAAAAAAAAAAAAD/8QAGhEBAAIDAQAAAAAAAAAAAAAAAQACAxFhIv/aAAwDAQACEQMRAD8AmamocyoU8G3TdF4066lxuIUElfnpiIj4KjXfWFnfQcJ//9k=","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./content/about.tsx
// @ts-ignore


















var ABOUT = {
    stats: [
        {
            statistic: "".concat(new Date(Date.now() - new Date("1986-01-08T01:30:00").getTime()).getFullYear() - 1970),
            tooltip: "".concat(Math.round((Date.now() - new Date("1986-01-08T01:30:00").getTime()) / 1000), " seconds"),
            caption: "Years Old"
        },
        {
            statistic: "10+",
            tooltip: "First line of code written in 1997",
            caption: "Years Web Dev"
        },
        {
            statistic: "1",
            tooltip: "Who also loves running.",
            caption: "Amazing dog"
        },
        {
            statistic: "3149",
            tooltip: "111 GitHub Stars",
            caption: "Commits"
        }, 
    ],
    description: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                children: [
                    "I'm a Cape Town based Web Developer and Entrepreneur. My focus area for the past few years has been front-end development with ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Next.js"
                    }),
                    ", ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "Typescript"
                    }),
                    " ",
                    "and ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "TailwindCSS"
                    }),
                    " to create beautiful user- and developer experiences that bring delight."
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "I’ve spent most of my life deeply interested in technology and food, continuously building things with both. As a teenager, I was a classic computer nerd, spending most of my times messing with the computer, doing 1 of 4 things: Modding games and figuring things out. Tinkering with hardware, building computers. Developing websites with FrontPage 98 and Flash. And of course, playing games."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "Most of that is still true today."
            })
        ]
    }),
    images: [
        {
            src: dont_be_a_dick,
            alt: "With Liz and Alpha at House of the Machines"
        },
        {
            src: profile_lionshead,
            alt: "Hiking up the slopes of Table mountain with Lions-head in the background"
        },
        {
            src: namibia,
            alt: "Overseeing the desert in Namibia."
        },
        {
            src: quadbike,
            alt: "Driving quadbike in the dunes of Swakopmund."
        },
        {
            src: alpha_backpack,
            alt: "Hiking for 33km over Table mountain and giving Alpha a little rest in the backpack."
        },
        {
            src: christmas_wilderness,
            alt: "Family Friends posing for Christmas in Wilderness, SA."
        },
        {
            src: ottertrail,
            alt: "Reflection of our 5 day hike with a beautiful water shot."
        },
        {
            src: running,
            alt: "Running down the slopes in Newlands forest."
        },
        {
            src: restaurant,
            alt: "Our Restaurant that we had in Knysna, The Exchange, woodfired Grill."
        },
        {
            src: restaurant_diy,
            alt: "DIY upgrading our restaurant, including soundproofing."
        },
        {
            src: wedding,
            alt: "Walking down the isle for our wedding."
        },
        {
            src: alpha_mountain,
            alt: "Alpha smiling on top of Lions head"
        },
        {
            src: kirstenbosch,
            alt: "Christmas carols in Kirstenbosch, Newlands."
        },
        {
            src: camping,
            alt: "Camping at Addo Elephant national Park."
        },
        {
            src: great_ideas,
            alt: "Reading a new book in a Jacuzzi in Cederkloof, Citrusdal."
        },
        {
            src: desert,
            alt: "Standing in the desert in Namibia."
        },
        {
            src: profile_adelphi,
            alt: "Family pic in our home in Vredehoek, Cape Town."
        }, 
    ]
};

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/sections/about.tsx






var About = function(props) {
    var ref;
    var imageRef = (0,react.useRef)([]);
    var ref1 = (0,react.useState)(0), focusImageIndex = ref1[0], setFocusImageIndex = ref1[1];
    var ref2 = (0,react.useState)(ABOUT.images), images = ref2[0], setImages = ref2[1];
    var ref3 = (0,_sliced_to_array/* default */.Z)((0,tooltip_store/* useTooltipStore */._)(), 2), tooltip = ref3[0], setTooltip = ref3[1];
    var buttonRef = (0,react.useRef)(null);
    var handleImageClick = (0,react.useCallback)(function() {
        setTooltip(false);
        if (focusImageIndex === images.length - 1) {
            setFocusImageIndex(function(current) {
                return current + 1;
            });
            setImages(function(current) {
                return current.sort(function() {
                    return 0.5 - Math.random();
                });
            });
            setTimeout(function() {
                setFocusImageIndex(0);
                setTooltip(true);
                var trigger = new Event("mouseover");
                setTimeout(function() {
                    var ref;
                    (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(trigger);
                }, 50);
            }, 350);
        }
        if (focusImageIndex < images.length - 1) {
            setFocusImageIndex(function(current) {
                return current + 1;
            });
            setTimeout(function() {
                setTooltip(true);
                var trigger = new Event("mouseover");
                setTimeout(function() {
                    var ref;
                    (ref = buttonRef.current) === null || ref === void 0 ? void 0 : ref.dispatchEvent(trigger);
                }, 50);
            }, 50);
        }
    }, [
        focusImageIndex,
        images.length,
        setTooltip
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        id: "about",
        className: "-mt-12 overflow-hidden pt-12",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "mx-auto flex max-w-6xl flex-col justify-center gap-16 px-4 pb-16 md:px-8 lg:grid lg:grid-cols-[540px_auto] lg:pt-16",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    ref: buttonRef,
                    className: "group relative mx-auto mb-12 aspect-3/2 max-h-[405px] w-full max-w-[540px] flex-1 hfa:outline-none lg:mb-auto lg:mr-0 lg:aspect-4/3",
                    onClick: handleImageClick,
                    type: "button",
                    "data-event": "mouseover",
                    "data-tip": (ref = images[focusImageIndex]) === null || ref === void 0 ? void 0 : ref.alt,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "sr-only",
                            children: "Cycle through Images"
                        }),
                        images.map(function(param, index) {
                            var src = param.src, alt = param.alt;
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                maxWidth: 540,
                                src: src,
                                alt: alt,
                                width: 2000,
                                height: 1500,
                                sizes: "(min-width: 580px) 540px, 400px",
                                preload: true,
                                priority: index === 0,
                                className: "absolute left-0 top-0 rounded-xl border-2 border-gray-50/80 object-cover !opacity-0 shadow-lg shadow-gray-700/5 transition-all duration-300 group-focus-visible:border-sky-500 d:border-gray-600/80",
                                "data-about-image-index": index,
                                onLoadingComplete: function() {
                                    return document.querySelectorAll('[data-about-image-index="'.concat(index, '"]')).forEach(function(img) {
                                        return img.classList.remove("!opacity-0");
                                    });
                                },
                                style: {
                                    transform: focusImageIndex > index ? "translate(-700px, -".concat(index % 4 * 60 + 25, "px) rotate(").concat(index % 4 * (index % 2 === 0 ? 0.5 : -1.2) * 3, "deg)") : "rotate(".concat(index % 4 * (index % 2 === 0 ? 0.5 : -1.2) * 3, "deg)"),
                                    zIndex: -index,
                                    filter: focusImageIndex !== index ? "grayscale(80)" : "",
                                    opacity: focusImageIndex > index ? "0" : "1"
                                }
                            }, alt);
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative -z-50 h-full w-full -rotate-6 rounded-xl bg-gray-200/80"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "spacing-8",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: "grid max-w-xl grid-cols-2 gap-4 text-center sm:grid-cols-4 sm:text-left",
                            children: ABOUT.stats.map(function(param, index) {
                                var statistic = param.statistic, caption = param.caption, tooltip = param.tooltip;
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
                                    "data-tip": tooltip,
                                    className: "cursor-help select-none spacing-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "bg-gradient-to-r from-cyan-500 to-blue-600 bg-clip-text text-4xl font-extrabold tracking-tighter text-transparent",
                                            children: statistic
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figcaption", {
                                            className: "text-[15px] font-semibold tracking-tight text-gray-400 d:text-gray-300/80",
                                            children: caption
                                        })
                                    ]
                                }, caption + index);
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                            className: "tracking tight max-w-3xl leading-relaxed text-gray-500 d:text-gray-100/70 [&>p+p]:mt-4",
                            children: ABOUT.description
                        })
                    ]
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs + 1 modules
var _object_spread = __webpack_require__(41799);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/HeartIcon.js
var HeartIcon = __webpack_require__(71644);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/StarIcon.js
var StarIcon = __webpack_require__(61646);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/MoonIcon.js
var MoonIcon = __webpack_require__(66459);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/SunIcon.js
var SunIcon = __webpack_require__(15040);
// EXTERNAL MODULE: ./components/link.tsx + 1 modules
var components_link = __webpack_require__(24614);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./utils/capitalize.ts
var capitalize = __webpack_require__(54096);
;// CONCATENATED MODULE: ./components/badge.tsx



var Badge = function(param) {
    var children = param.children, _size = param.size, size = _size === void 0 ? "md" : _size, _style = param.style, style = _style === void 0 ? "plain" : _style;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: (0,clsx_m/* default */.Z)("inline-flex select-none items-center whitespace-nowrap rounded-md border-2 font-medium transition-all", {
            sm: "px-1.5 py-0.5 text-xs",
            md: "px-2.5 py-0.5 text-[13px]",
            lg: "px-3 py-1 text-[13px]"
        }[size], {
            info: "cursor-pointer border-cyan-700/20 bg-cyan-100 text-cyan-900 hfa:bg-cyan-200/90 d:border-cyan-400/30 d:bg-gradient-to-b d:from-cyan-900/90 d:to-cyan-900/90 d:text-cyan-100 d:hfa:from-cyan-900/70 d:hfa:to-cyan-900/70",
            success: "cursor-pointer border-green-700/20 bg-green-100 text-green-900 hfa:bg-green-200/90 d:border-green-400/30 d:bg-gradient-to-b d:from-green-900/90 d:to-green-900/90 d:text-green-100 d:hfa:from-green-900/70 d:hfa:to-green-900/70",
            attention: "cursor-pointer border-yellow-700/20 bg-yellow-100 text-yellow-900 hfa:bg-yellow-200/90 d:border-yellow-400/30 d:bg-gradient-to-b d:from-yellow-900/90 d:to-yellow-900/90 d:text-yellow-100 d:hfa:from-yellow-900/70 d:hfa:to-yellow-900/70",
            warning: "cursor-pointer border-orange-700/20 bg-orange-100 text-orange-900 hfa:bg-orange-200/90 d:border-orange-400/30 d:bg-gradient-to-b d:from-orange-900/90 d:to-orange-900/90 d:text-orange-100 d:hfa:from-orange-900/70 d:hfa:to-orange-900/70",
            critical: "cursor-pointer border-red-700/20 bg-red-100 text-red-900 hfa:bg-red-200/90 d:border-red-400/30 d:bg-gradient-to-b d:from-red-900/90 d:to-red-900/90 d:text-red-100 d:hfa:from-red-900/70 d:hfa:to-red-900/70",
            accent: "cursor-pointer border-pink-700/20 bg-pink-100 text-pink-900 hfa:bg-pink-200/90 d:border-pink-400/30 d:bg-gradient-to-b d:from-pink-900/90 d:to-pink-900/90 d:text-pink-100 d:hfa:from-pink-900/70 d:hfa:to-pink-900/70",
            plain: "cursor-pointer border-gray-700/20 bg-gray-100 text-gray-900 hfa:bg-gray-200/90 d:border-gray-400/30 d:bg-gradient-to-b d:from-gray-900/90 d:to-gray-900/90 d:text-gray-100 d:hfa:from-gray-900/70 d:hfa:to-gray-900/70",
            disabled: "cursor-not-allowed border-gray-700/5 bg-gray-100 text-gray-400"
        }[style]),
        children: (0,capitalize/* capitalize */.k)(children)
    });
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ClipboardDocumentCheckIcon.js
var ClipboardDocumentCheckIcon = __webpack_require__(83166);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ClipboardDocumentIcon.js
var ClipboardDocumentIcon = __webpack_require__(64202);
// EXTERNAL MODULE: ./components/toast.tsx + 12 modules
var toast = __webpack_require__(75964);
// EXTERNAL MODULE: ./node_modules/react-use/esm/useCopyToClipboard.js + 2 modules
var useCopyToClipboard = __webpack_require__(86366);
;// CONCATENATED MODULE: ./components/copy-button.tsx







var CopyButton = function(param) {
    var content = param.content, className = param.className;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useCopyToClipboard/* default */.Z)(), 2), state = ref[0], copyToClipboard = ref[1];
    var ref1 = (0,toast/* useToast */.pm)(), toasts = ref1.toasts, addToast = ref1.addToast;
    var handleCopyCode = (0,react.useCallback)(function() {
        copyToClipboard(content);
        addToast({
            id: "copy-code",
            message: "Code Copied to Clipboard",
            timestamp: Date.now()
        });
    }, [
        addToast,
        content,
        copyToClipboard
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
        className: (0,clsx_m/* default */.Z)(className, "h-5 w-5 transition-colors"),
        onClick: handleCopyCode,
        type: "button",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "sr-only",
                children: "Copy code"
            }),
            toasts.some(function(notification) {
                return notification.id === "copy-code";
            }) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardDocumentCheckIcon/* default */.Z, {
                className: "h-5 w-5 text-sky-400"
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ClipboardDocumentIcon/* default */.Z, {
                className: "h-5 w-5"
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./node_modules/prismjs/prism.js
var prism = __webpack_require__(15660);
;// CONCATENATED MODULE: ./components/typography/code.tsx






var Code = function(param) {
    var language = param.language, plugins = param.plugins, lineHighlight = param.lineHighlight, code = param.code, className = param.className;
    var loadDependencies = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(language === "tsx")) return [
                        3,
                        3
                    ];
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 62356).then(__webpack_require__.t.bind(__webpack_require__, 62356, 23))
                    ];
                case 1:
                    _state.sent();
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 96836).then(__webpack_require__.t.bind(__webpack_require__, 96836, 23))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    if (!(language === "html")) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 24335).then(__webpack_require__.t.bind(__webpack_require__, 24335, 23))
                    ];
                case 4:
                    _state.sent();
                    _state.label = 5;
                case 5:
                    if (!(language !== "html")) return [
                        3,
                        7
                    ];
                    return [
                        4,
                        __webpack_require__(96316)("./prism-".concat(language))
                    ];
                case 6:
                    _state.sent();
                    _state.label = 7;
                case 7:
                    if (!(plugins === null || plugins === void 0 ? void 0 : plugins.includes("line-numbers"))) return [
                        3,
                        9
                    ];
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 98759).then(__webpack_require__.t.bind(__webpack_require__, 98759, 23))
                    ];
                case 8:
                    _state.sent();
                    _state.label = 9;
                case 9:
                    if (!(plugins === null || plugins === void 0 ? void 0 : plugins.includes("highlight-keywords"))) return [
                        3,
                        11
                    ];
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 97193).then(__webpack_require__.t.bind(__webpack_require__, 97193, 23))
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    if (!lineHighlight) return [
                        3,
                        13
                    ];
                    // @ts-ignore
                    return [
                        4,
                        __webpack_require__.e(/* import() */ 88921).then(__webpack_require__.t.bind(__webpack_require__, 88921, 23))
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    (0,prism.highlightAll)();
                    return [
                        2
                    ];
            }
        });
    }), [
        language,
        lineHighlight,
        plugins
    ]);
    (0,react.useEffect)(function() {
        loadDependencies();
    }, [
        language,
        loadDependencies
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("pre", {
        className: (0,clsx_m/* default */.Z)(plugins, lineHighlight && "line-highlight", "language-".concat(language), className),
        "data-line": lineHighlight,
        tabIndex: -1,
        children: (Array.isArray(code) ? code : [
            code
        ]).map(function(code, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                        className: "language-".concat(language),
                        "data-selected-index": index,
                        children: code
                    }),
                    "\n"
                ]
            }, index);
        })
    });
};

;// CONCATENATED MODULE: ./components/code-editor.tsx



var CodeEditor = function(param) {
    var code = param.code, language = param.language;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("figure", {
        className: "relative w-full flex-col overflow-hidden rounded-md border-2 border-gray-200/40 bg-gray-900 p-2.5 shadow-2xl drop-shadow-lg d:border-gray-600/40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "mb-2 grid items-center border-b border-b-gray-800 pb-2",
                style: {
                    gridTemplateColumns: "50px 1fr 50px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("i", {
                        className: "flex gap-1.5",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: -1,
                                "aria-hidden": true,
                                className: "h-3 w-3 rounded-full bg-gray-700 transition-colors h:bg-[#EC6A5F]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: -1,
                                "aria-hidden": true,
                                className: "h-3 w-3 rounded-full bg-gray-700 transition-colors h:bg-[#F4BF50]"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                tabIndex: -1,
                                "aria-hidden": true,
                                className: "h-3 w-3 rounded-full bg-gray-700 transition-colors h:bg-[#61C454]"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "color select-none text-center text-[13px] leading-none tracking-wide text-gray-500",
                        children: "/index.tsx"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyButton, {
                            content: Array.isArray(code) ? code.join("\n") : code,
                            className: "text-gray-500 hf:text-white"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                className: " relative h-[calc(100%-37px)] overflow-hidden before:absolute b:pointer-events-none b:bottom-0 b:z-10 b:h-12 b:w-full b:select-none b:bg-gradient-to-b b:from-transparent b:to-gray-900",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "sm:scrollbar-none relative h-full overflow-auto ",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Code, {
                        className: "text-[13px]",
                        code: code,
                        language: language
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/switch/switch.js + 9 modules
var switch_switch = __webpack_require__(73755);
;// CONCATENATED MODULE: ./components/toggle-switch.tsx




var ToggleSwitch = function(param) {
    var enabled = param.enabled, setEnabled = param.setEnabled, enabledIcon = param.enabledIcon, disabledIcon = param.disabledIcon;
    var ref;
    var switchRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(switch_switch/* Switch */.r, {
            ref: switchRef,
            checked: enabled,
            onChange: setEnabled,
            className: (0,clsx_m/* default */.Z)(enabled ? " from-pink-400 to-violet-500" : "from-yellow-200 to-orange-300", "relative h-9 w-16 flex-shrink-0 cursor-pointer rounded-full border-2 border-gray-500/40 bg-gradient-to-r bg-clip-padding p-0.5 transition-colors duration-200 ease-in-out focus:outline-none"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "sr-only",
                    children: "Switch Color Theme"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (0,clsx_m/* default */.Z)(enabled ? "translate-x-[calc(100%)]" : "translate-x-0", "pointer-events-none relative aspect-1 h-full transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out"),
                    style: {
                        transform: enabled ? "translateX(calc(".concat((ref = switchRef.current) === null || ref === void 0 ? void 0 : ref.clientWidth, "px - 100% - 4px))") : "translateX(0px)"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: (0,clsx_m/* default */.Z)(enabled ? "opacity-0 duration-100 ease-out" : "opacity-100 duration-200 ease-in", "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"),
                            "aria-hidden": "true",
                            children: disabledIcon
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                            className: (0,clsx_m/* default */.Z)(enabled ? "opacity-100 duration-200 ease-in" : "opacity-0 duration-100 ease-out", "absolute inset-0 flex h-full w-full items-center justify-center transition-opacity"),
                            "aria-hidden": "true",
                            children: enabledIcon
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var toggle_switch = (ToggleSwitch);

;// CONCATENATED MODULE: ./components/twitter-profile.tsx



var TwitterProfile = function(param) {
    var profile_image_url = param.profile_image_url, name = param.name, username = param.username, description = param.description, public_metrics = param.public_metrics;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "max-w-xs animate-float rounded-lg border-2 border-gray-400/30 bg-white/90 p-4 backdrop-blur-md will-change-transform spacing-2 d:bg-gray-800 lg:bg-white/80",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "flex gap-4",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                        className: "overflow-hidden rounded-full border-2 border-gray-400/50",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                            width: 40,
                            height: 40,
                            src: profile_image_url,
                            alt: name,
                            className: "rounded-full border-2 border-accent"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col justify-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                className: "text-sm font-semibold tracking-wide",
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                className: "text-sm tracking-tight text-gray-500 d:text-gray-300/90",
                                children: [
                                    "@",
                                    username
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                        target: "_blank",
                        href: "https://twitter.com/".concat(username),
                        className: "butter-border my-auto ml-auto flex items-center justify-center rounded-full bg-sky-500/90 py-1.5 px-4 text-xs text-white transition-colors hfa:bg-sky-600/80 d:bg-sky-600/90 d:hfa:bg-sky-500/80",
                        children: "Follow"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    className: "pr-2 text-[13px] tracking-tight text-gray-500/90 line-clamp-3 d:text-gray-300/90",
                    children: description
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                    className: "text-[13px] text-gray-500 d:text-gray-300/90",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "font-semibold text-gray-600 d:text-gray-200",
                            children: public_metrics === null || public_metrics === void 0 ? void 0 : public_metrics.following_count
                        }),
                        " ",
                        "Following",
                        " ",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "ml-2 font-semibold text-gray-600 d:text-gray-200",
                            children: public_metrics === null || public_metrics === void 0 ? void 0 : public_metrics.followers_count
                        }),
                        " ",
                        "Followers"
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./node_modules/raw-loader/dist/cjs.js!./content/code-blocks/hero.tsx
/* harmony default export */ var hero = ("import { FC } from \"react\";\n\ntype WelcomeProps = {\n  uses:\n    | \"explore new tech\"\n    | \"display my skills\"\n    | \"find freelancing opportunities\"\n    | \"find a fulltime job\";\n};\n\nexport const Welcome: FC<WelcomeProps> = ({ uses }) => {\n  return (\n    <>\n      <h1>This is my little slice of the internet.</h1>\n      <p>\n        I use this site to <em>{uses}</em>.\n      </p>\n    </>\n  );\n};\n\nexport default Welcome;\n");
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiNodeDotJs.js
var SiNodeDotJs = __webpack_require__(22555);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiShopify.js
var SiShopify = __webpack_require__(58493);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiTailwindcss.js
var SiTailwindcss = __webpack_require__(51870);
// EXTERNAL MODULE: ./content/tech-stack.tsx + 22 modules
var tech_stack = __webpack_require__(21222);
// EXTERNAL MODULE: ./node_modules/party-js/lib/index.js
var lib = __webpack_require__(94393);
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);
;// CONCATENATED MODULE: ./content/hero.tsx
// @ts-ignore

 // Adding `!!` to a request will disable all loaders specified in the configuration






var HERO = {
    pre: "Welcome to my site.",
    heading: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "I'm ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                children: "Felix Tellmann"
            }),
            ", a Fullstack developer."
        ]
    }),
    tech: [
        tech_stack/* TECH.nextjs */.O.nextjs,
        {
            name: "Node.js",
            Icon: function(param) {
                var className = param.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiNodeDotJs/* SiNodeDotJs */.t, {
                    className: className
                });
            }
        },
        {
            name: "Tailwind",
            Icon: function(param) {
                var className = param.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiTailwindcss/* SiTailwindcss */.Y, {
                    className: className
                });
            }
        },
        {
            name: "Shopify",
            Icon: function(param) {
                var className = param.className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiShopify/* SiShopify */.F, {
                    className: className
                });
            }
        }, 
    ],
    body: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            "I love writing code that takes things next level creating highly performant websites, automated API integrations, building my own dev-tools, and creating stunning user-experiences that makes you feel",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("em", {
                className: "relative cursor-pointer before:absolute b:bottom-0 b:-z-10 b:h-3 b:w-full b:-rotate-2 b:animate-hint-hint b:bg-pink-400/70 b:blur-sm d:b:bg-pink-600",
                onClick: function(e) {
                    e.currentTarget.classList.remove("before:absolute");
                    lib_default().confetti(e.currentTarget, {
                        count: 40
                    });
                },
                children: "WOW!"
            }),
            ".",
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: "mt-4 block"
            }),
            "I am always keen to learn and explore new technologies, frameworks and programming languages. Currently, I'm learning about",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                target: "_blank",
                href: "https://astro.build/",
                className: "underline hfa:text-sky-500",
                children: "Astro"
            }),
            " ",
            "and",
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                href: "https://replicache.dev",
                target: "_blank",
                className: "underline hfa:text-sky-500",
                children: "Replicache"
            }),
            "."
        ]
    }),
    cta1: {
        href: "mailto:hello@flext.dev",
        name: "Let's Work"
    },
    cta2: {
        href: "/resume",
        name: "Resume"
    },
    code: "".concat(hero)
};

// EXTERNAL MODULE: ./node_modules/next-themes/dist/index.module.js
var index_module = __webpack_require__(82010);
;// CONCATENATED MODULE: ./components/sections/hero.tsx










var Hero = function(param) {
    var twitterData = param.twitterData;
    var ref = (0,index_module/* useTheme */.F)(), theme = ref.theme, setTheme = ref.setTheme;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "hero relative overflow-hidden pb-40",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative mx-auto flex max-w-6xl grid-cols-3 flex-col gap-8 gap-y-16 px-4 py-16 md:py-32 md:px-8 lg:grid",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "col-span-2",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "heading-pre",
                                    children: HERO.pre
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "heading-hero ",
                                    children: HERO.heading
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                    className: "sm:scrollbar-none -mx-4 mb-2 flex items-center gap-6 overflow-x-auto px-4 pb-2 text-[15px] font-medium",
                                    children: HERO.tech.map(function(param) {
                                        var name = param.name, Icon = param.Icon;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex items-center gap-2 text-gray-500 d:text-gray-400",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                    className: "h-7 w-7 text-gray-400 d:text-gray-300/80"
                                                }),
                                                name
                                            ]
                                        }, name);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-3 max-w-prose font-normal text-gray-500 d:text-gray-400 md:text-lg md:tracking-tight",
                                    children: HERO.body
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "mb-3 max-w-xl font-normal text-gray-500 md:text-lg md:tracking-tight"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                            className: "mt-6 flex flex-wrap gap-4 md:gap-8",
                            children: [
                                HERO.cta1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                    href: HERO.cta1.href,
                                    className: "button-rainbow inline-flex whitespace-nowrap bg-gray-800 px-10 py-2.5 text-sm font-medium tracking-tight text-gray-50 hfa:border-gray-300/90 hfa:bg-gray-900 hfa:text-white d:hfa:border-gray-700/30 md:px-12",
                                    children: HERO.cta1.name
                                }) : null,
                                HERO.cta2 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_link/* Link */.r, {
                                    href: HERO.cta2.href,
                                    className: "button-border inline-flex whitespace-nowrap bg-white/90 px-10 py-2.5 text-sm font-medium tracking-tight text-gray-500 transition-all hfa:border-gray-900/70 hfa:bg-white/90 hfa:text-gray-900 d:border-gray-700/80 d:bg-transparent d:text-gray-300 d:hfa:border-gray-200/30 d:hfa:bg-gray-900/80 d:hfa:text-gray-50 md:px-12",
                                    children: HERO.cta2.name
                                }) : null
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                    className: "relative md:h-[420px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex h-full min-w-[460px] flex-col gap-4 sm:min-w-[660px] lg:absolute lg:left-8 lg:top-16 lg:left-6 lg:top-24 lg:min-w-[460px]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative z-20 flex justify-end gap-1.5",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "info",
                                            children: "Hiker"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "success",
                                            children: "Chef"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "warning",
                                            children: "Runner"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "accent",
                                            children: "Mixologist"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Badge, {
                                            style: "plain",
                                            children: "Space Enthusiast"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "relative flex h-full flex-col",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeEditor, {
                                            code: HERO.code,
                                            language: "tsx"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "absolute -right-5 -bottom-5 -z-10 h-[calc(100%+1.25rem)] w-[calc(100%+1.25rem)] rounded-lg border border-gray-400/20 bg-gray-100/70 [mask-image:linear-gradient(-30deg,#fff_16.35%,rgb(255_255_255_/_0%)_61.66%)] d:border-gray-700/20 d:bg-gray-900/40"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "z-10 mt-1 flex gap-2 lg:-mt-2 lg:ml-16",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                            target: "_blank",
                                            href: "https://www.buymeacoffee.com/felixtellmann",
                                            className: "group flex items-center justify-center rounded-full border-2 border-gray-400/50 bg-gray-100 bg-clip-padding py-1.5 px-3 text-sm font-medium text-gray-600 transition-all hfa:border-rose-500/30 hfa:bg-rose-500 hfa:text-white d:bg-gray-700 d:text-gray-50 d:hfa:bg-rose-500",
                                            "data-tip": "Buy me a coffee",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(HeartIcon/* default */.Z, {
                                                    className: "mr-1 h-4 w-4 animate-heartbeat text-red-600 transition-all group-hfa:text-white"
                                                }),
                                                "Support"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                            target: "_blank",
                                            href: "https://github.com/FelixTellmann/flext/stargazers",
                                            className: "group flex h-9 w-9 items-center justify-center rounded-full border-2 border-gray-400/50 bg-gray-100 bg-clip-padding text-sm font-medium text-gray-600 transition-all hfa:border-yellow-500/30 hfa:bg-yellow-500 hfa:text-white d:bg-gray-700 d:text-gray-50 d:hfa:bg-yellow-500",
                                            "data-tip": "Star on Github",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "sr-only",
                                                    children: "Star on Github"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* default */.Z, {
                                                    className: "h-4 w-4 text-yellow-500 group-hfa:text-white"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(toggle_switch, {
                                            enabled: theme === "dark",
                                            setEnabled: function(bool) {
                                                return setTheme(bool ? "dark" : "light");
                                            },
                                            enabledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(MoonIcon/* default */.Z, {
                                                className: "h-3 w-3 text-slate-400"
                                            }),
                                            disabledIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(SunIcon/* default */.Z, {
                                                className: "h-4 w-4 text-orange-400"
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute hidden sm:top-24 sm:-right-5 sm:block lg:top-full lg:-left-64",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterProfile, (0,_object_spread/* default */.Z)({}, twitterData))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "background pointer-events-none absolute inset-0 z-0 -z-30 select-none",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative top-1/2 left-1/2 h-2/3 w-1/2 -translate-y-[30%] rounded-full bg-gradient-radial from-emerald-600/30 to-sky-600/5 blur-2xl"
                    })
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/LinkIcon.js
var LinkIcon = __webpack_require__(26662);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaGithub.js
var FaGithub = __webpack_require__(69211);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ArrowLongLeftIcon.js
var ArrowLongLeftIcon = __webpack_require__(45751);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ArrowLongRightIcon.js
var ArrowLongRightIcon = __webpack_require__(84009);
// EXTERNAL MODULE: ./utils/scroll-to.tsx
var scroll_to = __webpack_require__(76811);
;// CONCATENATED MODULE: ./components/scroll-gallery.tsx




var ScrollGallery = function(param) {
    var itemWidth = param.itemWidth, gapWidth = param.gapWidth, children = param.children, filter = param.filter;
    var scrollContainerRef = (0,react.useRef)(null);
    var ref = (0,react.useState)({
        prev: false,
        next: true
    }), scrollNavigation = ref[0], setScrollNavigation = ref[1];
    var ref1 = (0,react.useState)(false), isScrolling = ref1[0], setIsScrolling = ref1[1];
    var handleClickPrevious = (0,react.useCallback)(function() {
        if (isScrolling) return;
        var scrollContainer = scrollContainerRef.current;
        scrollContainer.classList.remove("snap-x");
        setIsScrolling(true);
        (0,scroll_to/* scrollToX */.T)(200, Math.max((scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollLeft) - itemWidth - gapWidth, 0), scrollContainer, function() {
            setIsScrolling(false);
            scrollContainer.classList.add("snap-x");
        });
    }, [
        gapWidth,
        isScrolling,
        itemWidth
    ]);
    var handleClickNext = (0,react.useCallback)(function() {
        if (isScrolling) return;
        var scrollContainer = scrollContainerRef.current;
        scrollContainer.classList.remove("snap-x");
        setIsScrolling(true);
        (0,scroll_to/* scrollToX */.T)(200, scrollContainer.scrollLeft + itemWidth + gapWidth, scrollContainer, function() {
            setIsScrolling(false);
            scrollContainer.classList.add("snap-x");
        });
    }, [
        gapWidth,
        isScrolling,
        itemWidth
    ]);
    (0,react.useEffect)(function() {
        var scrollContainer = scrollContainerRef.current;
        var updateScrollNavigation = function() {
            setScrollNavigation(function() {
                var ref;
                return {
                    prev: (scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.scrollLeft) > 0,
                    next: ((ref = scrollContainer.children[scrollContainer.children.length - 1]) === null || ref === void 0 ? void 0 : ref.getBoundingClientRect().right) > window.innerWidth
                };
            });
        };
        scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.addEventListener("scroll", updateScrollNavigation);
        return function() {
            scrollContainer === null || scrollContainer === void 0 ? void 0 : scrollContainer.removeEventListener("scroll", updateScrollNavigation);
        };
    }, []);
    (0,react.useEffect)(function() {
        var scrollContainer = scrollContainerRef.current;
        scrollContainer.classList.remove("snap-x");
        setIsScrolling(true);
        (0,scroll_to/* scrollToX */.T)(200, 0, scrollContainer, function() {
            setIsScrolling(false);
            scrollContainer.classList.add("snap-x");
        });
    }, [
        filter,
        gapWidth,
        itemWidth
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                    className: "sm:scrollbar-none group relative flex snap-x snap-mandatory scroll-pl-[max(var(--slider-padding),calc((100%-72rem)/2+var(--slider-padding)))] gap-8 overflow-x-auto py-12 px-[max(var(--slider-padding),calc((100%-72rem)/2+var(--slider-padding)))] [--slider-padding:2rem]",
                    ref: scrollContainerRef,
                    children: children
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "absolute left-10 bottom-0 hidden items-center gap-2 py-2 px-4 text-sm text-gray-500 transition-all duration-75 disabled:text-gray-300 h:text-gray-900 disabled:h:text-gray-300 d:text-gray-300 d:disabled:text-gray-700 d:hfa:text-gray-50 d:disabled:hfa:text-gray-700 md:flex",
                    onClick: handleClickPrevious,
                    disabled: !scrollNavigation.prev,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLongLeftIcon/* default */.Z, {
                            className: "mt-0.5 h-5 w-5"
                        }),
                        "prev"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                    className: "absolute right-10 bottom-0 hidden items-center gap-2 py-2 px-4 text-sm text-gray-500 transition-all duration-75 disabled:text-gray-300 h:text-gray-900 h:text-gray-900 disabled:h:text-gray-300 d:text-gray-300 d:disabled:text-gray-700 d:hfa:text-gray-50 d:disabled:hfa:text-gray-700 md:flex",
                    onClick: handleClickNext,
                    disabled: !scrollNavigation.next,
                    children: [
                        "next",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowLongRightIcon/* default */.Z, {
                            className: "mt-0.5 h-5 w-5"
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./content/portfolio-preview.tsx
var PORTFOLIO = {
    pre: "Portfolio",
    heading: "Checkout my work."
};

;// CONCATENATED MODULE: ./public/images/projects/Aiko.jpg
/* harmony default export */ var Aiko = ({"src":"/_next/static/media/Aiko.3d47b4e2.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAbEAEAAgIDAAAAAAAAAAAAAAABAAIDUQQRIv/EABQBAQAAAAAAAAAAAAAAAAAAAAX/xAAcEQACAAcAAAAAAAAAAAAAAAAAAQIEBSQzgbH/2gAMAwEAAhEDEQA/AK3m5beAK12lTtNREQmZyMVoisYN9Z//2Q==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/AlphabetPix.jpg
/* harmony default export */ var AlphabetPix = ({"src":"/_next/static/media/AlphabetPix.27b6413f.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAwIHAAAAAAAAAAAAAAAAAQMEERMCBhIiIzFx/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAWEQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhEDEQA/ALRIzi5gRxZsrRi5LNzZ5SnQAEVp/9k=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/BroadwayJewellers.jpg
/* harmony default export */ var BroadwayJewellers = ({"src":"/_next/static/media/BroadwayJewellers.7844d0f9.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAdEAABAwUBAAAAAAAAAAAAAAACAAEEAxESITEG/8QAFAEBAAAAAAAAAAAAAAAAAAAABP/EABYRAQEBAAAAAAAAAAAAAAAAAAEAEf/aAAwDAQACEQMRAD8AooHnYTR4YEVSpem2TljcubfXUREZWRhf/9k=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/BushScarf.jpg
/* harmony default export */ var BushScarf = ({"src":"/_next/static/media/BushScarf.8e0899a6.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAcEAABBQADAAAAAAAAAAAAAAABAAIDBBETYXH/xAAVAQEBAAAAAAAAAAAAAAAAAAAAAf/EABYRAQEBAAAAAAAAAAAAAAAAAAARAf/aAAwDAQACEQMRAD8AkJ7dirGeOU65xbpA0d+oiJdSP//Z","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/ClickUpload.jpg
/* harmony default export */ var ClickUpload = ({"src":"/_next/static/media/ClickUpload.b597a388.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAdEAACAQQDAAAAAAAAAAAAAAAAAQIDBBESE1Gh/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/AK27ajKfI4vbveS8yAAP/9k=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Erply Egypt.png
/* harmony default export */ var Erply_Egypt = ({"src":"/_next/static/media/Erply Egypt.319af8f1.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEXS2+Lb6vaxu8JmcHnV0cHNqUjBpWdVYGrErXjPpjoEe8j2AAAACnRSTlNPR1yGXMudm4ntILLRIwAAAAlwSFlzAAALEgAACxIB0t1+/AAAACRJREFUCJljYGRhYQADRlZOJnZmZgYGRg42BiYmJpAQIwMIAgAFSwBBMJEXPQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Erply Takealot.png
/* harmony default export */ var Erply_Takealot = ({"src":"/_next/static/media/Erply Takealot.88a1a86d.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEXa4ufM1tvu6+mwusFkptCIuNU3kcpweoJdZ3BXYGl3r9JvUzUHAAAAC3RSTlNMUUdciWrmfo6beWu0gugAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAkSURBVAiZFcGJEQAgEAKxBe7R/ht2THA3ksAzuWeFq5QEsPkeBvEAUl0eBV8AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/fx-style.png
/* harmony default export */ var fx_style = ({"src":"/_next/static/media/fx-style.80b97862.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAALVBMVEXQ2+Ld4eWj1+ft8ObX0tWXmdhzcdfDyMfOu6hN2PF02/BrrNquzd5sstwjj9JKkffzAAAAD3RSTlNQSmNGXHWrZouJfIZUlPWwl8qOAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJ0lEQVQImR3Bhw0AIAwDsIy2bP4/Fwkb+DbQ+hxVdyFCyjwCSdrmAwm8AIc5v/CLAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/kidsliving.jpg
/* harmony default export */ var kidsliving = ({"src":"/_next/static/media/kidsliving.6dad85c8.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAb/xAAgEAABAwIHAAAAAAAAAAAAAAABAAIDBRIEERMUITFB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwT/xAAYEQADAQEAAAAAAAAAAAAAAAAAAbERQf/aAAwDAQACEQMRAD8Ard3ULYpRUsSLZtMtBbk4E+8doiKXXaxes//Z","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Lunalemon.jpg
/* harmony default export */ var Lunalemon = ({"src":"/_next/static/media/Lunalemon.b88b5832.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAbEAADAAIDAAAAAAAAAAAAAAAAAQMCBREyYf/EABUBAQEAAAAAAAAAAAAAAAAAAAEC/8QAFxEBAAMAAAAAAAAAAAAAAAAAAQACIf/aAAwDAQACEQMRAD8Apu0dIa+lJ3qsuG+3oAJvjGgJs//Z","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Lunatag.jpg
/* harmony default export */ var Lunatag = ({"src":"/_next/static/media/Lunatag.c287d5a5.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAcEAACAgIDAAAAAAAAAAAAAAABAgADERIEIUH/xAAVAQEBAAAAAAAAAAAAAAAAAAADBP/EABkRAQACAwAAAAAAAAAAAAAAAAEAAhIhMf/aAAwDAQACEQMRAD8ArV3ApvdC7WDQ5Grke57iIkzUydRThP/Z","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Shopify CourierGuy.png
/* harmony default export */ var Shopify_CourierGuy = ({"src":"/_next/static/media/Shopify CourierGuy.ab677e6a.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAJFBMVEXc5+zEz9Lg5PiHjKrTtaSbmKm404t/i66aun6SpcfF2K2NtFw55QFtAAAADHRSTlNLVkSGbnyygppqf+E272ObAAAACXBIWXMAAAsSAAALEgHS3X78AAAAJUlEQVQImWNgYGRkAAMmNm5GZmZ2RgYmLg5GFlZORgYGJiawFAAFrwBRcXdQxQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Shopify Dear Systems.png
/* harmony default export */ var Shopify_Dear_Systems = ({"src":"/_next/static/media/Shopify Dear Systems.508cf4d7.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAHlBMVEXa4OfG09ji5f2Gzc1Qi4+404vH1sOaun7F2a2Ms1xbcjeFAAAACnRSTlNMVEJsobJcm3/i0U+UZAAAAAlwSFlzAAALEgAACxIB0t1+/AAAACRJREFUCJkdyMERACAIwLAWVGD/hT3NM+ABgdijK4EuzV/BcwEEvQA7vZbl6gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Shopify Vend Omnisend.png
/* harmony default export */ var Shopify_Vend_Omnisend = ({"src":"/_next/static/media/Shopify Vend Omnisend.2e237e48.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEXc4+zL19avvr2nt6VdvW+r1Lu50J95lIFta2+MtHCsyXuIvVG6AAAAC3RSTlNKVF9x22KDmr+rxuGkV+kAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAjSURBVAiZPcHBAQAgCAOxawFR9h+YnwlIVRIwL7Ov4ITt4FsGpQBMBEExOQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Shopify Vend.png
/* harmony default export */ var Shopify_Vend = ({"src":"/_next/static/media/Shopify Vend.7c6dc5f1.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAKlBMVEXX4OfI2tPf3vy40cHq6vvF2a2Js5Zgu3B5wYlYuWeLs1uWvKOaun2404u+jS/2AAAADnRSTlNMU0NdRX9/2Jf+5XGcsoCIxPUAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAlSURBVAiZBcGJAQAgDAKxo+Cv+69rAjKyoN6uuYagXdwPUIGEDwgIAHGGFSPXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Shopify-cms.png
/* harmony default export */ var Shopify_cms = ({"src":"/_next/static/media/Shopify-cms.314d7cc9.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAKlBMVEXV3uPh6vHg5Pi/yNJSUVPJ2MjF2K2orbKXm5+XnJ+404tsbXCbun6OtF0ZmMGkAAAADnRSTlNOSkRUnlh/YWlnsoqb4QjL6mwAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAnSURBVAiZY2BgZWVkAAEmLl5mbhYWZgYmNh5mdg5OkBATAyMjIwMACK4AdCAAxd4AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/shopify-ftp.png
/* harmony default export */ var shopify_ftp = ({"src":"/_next/static/media/shopify-ftp.99aae8f3.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEXY4ufG0tGwtrri5f1eXmBaWlybun6404tub3LF2K2Ns1xvmaxLAAAAC3RSTlNMVV1CkZabsol/4mG43c4AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAkSURBVAiZFcjHDQAwDMQw6Zy+/8CB+SQoCNR+njGBu0zSVbQPBVgARgtIClIAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/shopify-typed-node-api.png
/* harmony default export */ var shopify_typed_node_api = ({"src":"/_next/static/media/shopify-typed-node-api.7c557293.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAM1BMVEXa4+mUmZ1lXlx0pcOZtqvK2Mqrsbbi7e/q6fPE0tyEhIaxy4tUVlkulON9qHd4t+qlxmiMkCc2AAAAEXRSTlNMaYmDc1hdTURQc56b06GE89Dbm/QAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAnSURBVAiZBcGJAQAgCMSwquCB//7TmoB7IkDv7FZXR9OujZIQEUh8De0Ax1j1o50AAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Tellmann.jpg
/* harmony default export */ var Tellmann = ({"src":"/_next/static/media/Tellmann.8cce389c.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAf/xAAgEAABAwIHAAAAAAAAAAAAAAAAAgMEARIFERUhIjGR/8QAFQEBAQAAAAAAAAAAAAAAAAAAAgP/xAAVEQEBAAAAAAAAAAAAAAAAAAAAAf/aAAwDAQACEQMRAD8ApLeGxdQckWKvUrflXLzoADqcf//Z","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Vend Takealot.png
/* harmony default export */ var Vend_Takealot = ({"src":"/_next/static/media/Vend Takealot.8e54730c.png","height":900,"width":1800,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAMAAACEE47CAAAAIVBMVEXn5e3U3+Kwy9t0uYOOwJ1KmMlClss4kslswHxVns1gvnDn0uwdAAAAC3RSTlNITVaieKvR6LGa7wtyQ0kAAAAJcEhZcwAACxIAAAsSAdLdfvwAAAAjSURBVAiZHcOJCQBACMCwVr13/4EFA0GVCPD+5GywslgPZNoFpABJCM0bFQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/Waraq.jpg
/* harmony default export */ var Waraq = ({"src":"/_next/static/media/Waraq.d5d4ca0d.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAcEAACAgIDAAAAAAAAAAAAAAABAwACBAUREjH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABoRAAICAwAAAAAAAAAAAAAAAAECABEDITH/2gAMAwEAAhEDEQA/AKiNRr1BmcrFC2VyCsVre/UAkjzmIiJSRyRyIrUWF6n/2Q==","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./public/images/projects/ZoomPringing.jpg
/* harmony default export */ var ZoomPringing = ({"src":"/_next/static/media/ZoomPringing.b791356b.jpg","height":900,"width":1800,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAEAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAACAgAHAAAAAAAAAAAAAAABAgAEAwUGERIhYf/EABUBAQEAAAAAAAAAAAAAAAAAAAEE/8QAGhEAAgIDAAAAAAAAAAAAAAAAAQIABBExQf/aAAwDAQACEQMRAD8AmJqrOcKg/G4SwZdmZQT2fRERFtyiuqlTkdM//9k=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./content/projects.tsx
























var PROJECTS = [
    {
        name: "Lunatag",
        type: [
            "Shopify Apps"
        ],
        tech: [
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.vercel */.O.vercel,
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.reactjs */.O.reactjs,
            tech_stack/* TECH.tailwindcss */.O.tailwindcss,
            tech_stack/* TECH.prisma */.O.prisma,
            tech_stack/* TECH.planetscale */.O.planetscale,
            tech_stack/* TECH.trpc */.O.trpc,
            tech_stack/* TECH.jsdom */.O.jsdom, 
        ],
        url: "https://apps.shopify.com/lunatag",
        repository: "",
        description: "I've created a Shopify App that allows users to add Tags to any image on their Shopify site to upsell products. The app is available on the Shopify App store and works for all Shopify themes.",
        content: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "I build LunaTag together with @LizT as a solution to create shoppable images anywhere on a Shopify hosted site. The apps interface fully integrates into a Shopify backend."
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                    children: "The project had several core challenges: Iframe Proxying, Image tagging stacking context, reverse dom selectors, serverless Shopify app authentication."
                })
            ]
        }),
        featuredImage: Lunatag,
        year: "2022"
    },
    {
        name: "Tellmann",
        type: [
            "Marketing Sites"
        ],
        tech: [
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.vercel */.O.vercel,
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.reactjs */.O.reactjs
        ],
        url: "https://tellmann.co.za",
        repository: "https://github.com/FelixTellmann/tellmann.co.za",
        description: "Tellmann Shopify Ecommerce Agency Website. I've built the site to establish a basis to find new Web Development projects and promote Shopify services.",
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "I have create the Tellmann Shopify Ecommerce Agency Website in 2020 to establish a basis to find new Web Development projects."
            })
        }),
        featuredImage: Tellmann,
        year: "2020"
    },
    {
        name: "ClickUpload",
        type: [
            "Shopify Apps"
        ],
        tech: [
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.vercel */.O.vercel,
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.reactjs */.O.reactjs,
            tech_stack/* TECH.tailwindcss */.O.tailwindcss,
            tech_stack/* TECH.prisma */.O.prisma,
            tech_stack/* TECH.planetscale */.O.planetscale,
            tech_stack/* TECH.trpc */.O.trpc,
            tech_stack/* TECH.aws */.O.aws,
            tech_stack/* TECH.turborepo */.O.turborepo, 
        ],
        url: "https://apps.shopify.com/click-upload",
        repository: "",
        description: "ClickUpload enables Shopify store owners to let customers upload files to their orders. The Shopify App supports all file types and sizes. All files are linked to the order and can be downloaded easily.",
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "I build ClickUpload together with @LizT in order to allow merchants add file Upload capabilities to their Shopify site. The apps interface fully integrates into a Shopify backend."
            })
        }),
        featuredImage: ClickUpload,
        year: "2021"
    },
    {
        name: "Kids Living",
        type: [
            "Ecommerce Sites",
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.sass */.O.sass,
            tech_stack/* TECH.vend */.O.vend,
            tech_stack/* TECH.vercel */.O.vercel
        ],
        url: "https://kidsliving.co.za",
        repository: "",
        description: "Large scale Ecommerce website for a South African based client with 3 brick & mortar locations and over 3000 products.",
        content: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: "I have worked with Kids Living since 2017 as their Ecommerce success partner covering everything from web development, inventory management, and marketing to custom API integrations."
            })
        }),
        featuredImage: kidsliving,
        year: "2017"
    },
    {
        name: "Lunalemon",
        type: [
            "Marketing Sites"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.trpc */.O.trpc,
            tech_stack/* TECH.tailwindcss */.O.tailwindcss,
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.vercel */.O.vercel,
            tech_stack/* TECH.headlessui */.O.headlessui,
            tech_stack/* TECH.planetscale */.O.planetscale, 
        ],
        description: "Headless Web agency site utilizing Shopify's theme editor as a custom CMS. The site showcases my client oriented projects and promotes web development services.",
        featuredImage: Lunalemon,
        year: "2022",
        url: "https://kidsliving.co.za",
        repository: "https://github.com/FelixTellmann/lunalemon.dev"
    },
    {
        name: "shopify-ftp-access",
        type: [
            "Devtools"
        ],
        tech: [
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.swc */.O.swc,
            tech_stack/* TECH.shopify */.O.shopify
        ],
        year: "2017",
        repository: "https://github.com/FelixTellmann/shopify-ftp-access",
        description: "Shopify-ftp-access is an Open Source utility which acts as a proxy that allows you to use any FTP program while running the CLI to connect upload/download any shopify Theme files",
        featuredImage: shopify_ftp
    },
    {
        name: "Erply Egypt eInvoicing API",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.aws_lambda */.O.aws_lambda,
            tech_stack/* TECH.axios */.O.axios
        ],
        year: "2022",
        description: "This custom App runs on 5 min Cron Job to process any incoming sales data for a retail chain in Egypt, processing each invoice on the eInvoicing portal. The app includes an internal dashboard for any manual processing required.",
        featuredImage: Erply_Egypt
    },
    {
        name: "Zoom Printing",
        type: [
            "Ecommerce Sites"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.tailwindcss */.O.tailwindcss
        ],
        year: "2021",
        url: "https://www.zoomprinting.ca/",
        description: "I've built the Shopify site based on the Warehouse theme, with lots of custom integrations to enable up to 1000 product variants and add-on sales. I've migrated the client from a old legacy self-hosted server, building my own web-scrapers along the way.",
        featuredImage: ZoomPringing
    },
    {
        name: "Vend Takealot API",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.aws_lambda */.O.aws_lambda,
            tech_stack/* TECH.axios */.O.axios,
            tech_stack/* TECH.vend */.O.vend
        ],
        year: "2021",
        description: "Similar to the Erply Takealot integration, this app runs a scheduled script to ensure that sales & inventory levels are synchronized between two sales channels.",
        featuredImage: Vend_Takealot
    },
    {
        name: "Aiko",
        type: [
            "Ecommerce Sites"
        ],
        tech: [
            tech_stack/* TECH.figma */.O.figma,
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.tailwindcss */.O.tailwindcss,
            tech_stack/* TECH.typescript */.O.typescript
        ],
        year: "2022",
        url: "https://aikoplanet.com/",
        description: "I built a fully custom designed Shopify site, utilizing shopify-cms in a non-headless way, to ensure type safety throughout the project using Shopify Liquid templates.",
        featuredImage: Aiko
    },
    {
        name: "Shopify Courier Guy API",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.aws_lambda */.O.aws_lambda,
            tech_stack/* TECH.axios */.O.axios,
            tech_stack/* TECH.shopify */.O.shopify
        ],
        year: "2021",
        description: "An integration to connect sales directly to the popular shipping provided Courier Guy, reducing the need to manually process incoming orders for fulfillment.",
        featuredImage: Shopify_CourierGuy
    },
    {
        name: "shopify-cms",
        type: [
            "Devtools"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.graphql */.O.graphql,
            tech_stack/* TECH.reactjs */.O.reactjs,
            tech_stack/* TECH.tailwindcss */.O.tailwindcss
        ],
        year: "2022",
        repository: "https://github.com/FelixTellmann/shopify-cms",
        description: "Shopify-cms is another Open Source CLI that I've built. The package helps building a site with the Shopify Theme Editor as a Headless CMS and get fully typed data.",
        featuredImage: Shopify_cms
    },
    {
        name: "Erply Takealot sales API",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.aws_lambda */.O.aws_lambda,
            tech_stack/* TECH.axios */.O.axios
        ],
        year: "2021",
        description: "I've built an API integration to process inventory levels and sales between the two POS/Ecommerce platforms for an internal client.",
        featuredImage: Erply_Takealot
    },
    {
        name: "AlphabetPIX",
        type: [
            "Ecommerce Sites"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.javascript */.O.javascript,
            tech_stack/* TECH.sass */.O.sass
        ],
        year: "2017",
        url: "https://alphabetpix.com/",
        description: "Custom build Shopify-site / Web-app that allows customers to create their own named picture frame and generate image files on the fly for their checkout.",
        featuredImage: AlphabetPix
    },
    {
        name: "shopify-typed-node-api",
        type: [
            "Devtools"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.graphql */.O.graphql,
            tech_stack/* TECH.reactjs */.O.reactjs,
            tech_stack/* TECH.nodejs */.O.nodejs
        ],
        year: "2021",
        repository: "https://github.com/FelixTellmann/shopify-typed-node-api/",
        description: "Shopify-typed-node-api is an extension to the popular shopify-node-api, adding typescript support for all Rest & GraphQL endpoints provided by Shopify.",
        featuredImage: shopify_typed_node_api
    },
    {
        name: "Shopify Vend product API",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.aws_lambda */.O.aws_lambda,
            tech_stack/* TECH.axios */.O.axios,
            tech_stack/* TECH.graphql */.O.graphql,
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.vend */.O.vend
        ],
        year: "2020",
        description: "A custom integration, ensuring that relevant product data is kept synchronized between Vend POS and Shopify, based on a webhook architecture to push updates.",
        featuredImage: Shopify_Vend
    },
    {
        name: "BushScarf",
        type: [
            "Ecommerce Sites"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.javascript */.O.javascript,
            tech_stack/* TECH.sass */.O.sass
        ],
        year: "2016",
        url: "https://originalthings-za.myshopify.com/",
        description: "I worked with Bushscarf to develop their Shopify Website covering aspects from product photography, product image editing and product content creation.",
        featuredImage: BushScarf
    },
    {
        name: "Broadway Jewellers",
        type: [
            "Ecommerce Sites"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.sass */.O.sass,
            tech_stack/* TECH.aws */.O.aws
        ],
        year: "2020",
        url: "https://broadwayjewellers.co.za/",
        description: "My work with Broadway Jewellers started with migrating their site form WordPress to Shopify, I also covered an array of aspects from inventory management, digital marketing, SEO web solutions, web design upgrade to custom API solutions.",
        featuredImage: BroadwayJewellers
    },
    {
        name: "fx-style",
        type: [
            "Devtools"
        ],
        tech: [
            tech_stack/* TECH.prettier */.O.prettier,
            tech_stack/* TECH.eslint */.O.eslint,
            tech_stack/* TECH.typescript */.O.typescript
        ],
        year: "2020",
        repository: "https://github.com/FelixTellmann/fx-style",
        description: "I've created fx-style as a package to standardize my own code style across all projects, while minimizing devDependencies for each project.",
        featuredImage: fx_style
    },
    {
        name: "Shopify DearSystems API",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.aws_lambda */.O.aws_lambda,
            tech_stack/* TECH.axios */.O.axios,
            tech_stack/* TECH.shopify */.O.shopify
        ],
        year: "2022",
        description: "This integration allows my client to effectively synchronize their inventory between Dear and Shopify with multiple store locations and a complex VAT setup.",
        featuredImage: Shopify_Dear_Systems
    },
    {
        name: "Waraq Health",
        type: [
            "Ecommerce Sites"
        ],
        tech: [
            tech_stack/* TECH.shopify */.O.shopify,
            tech_stack/* TECH.typescript */.O.typescript,
            tech_stack/* TECH.sass */.O.sass,
            tech_stack/* TECH.aws */.O.aws
        ],
        year: "2021",
        url: "https://waraqhealth.com/",
        description: "I worked with Waraq to successfully develop their Shopify site, covering aspects from product image editing and content research and creation.",
        featuredImage: Waraq
    },
    {
        name: "Vend Shopify Omnisend API",
        type: [
            "Integrations"
        ],
        tech: [
            tech_stack/* TECH.nextjs */.O.nextjs,
            tech_stack/* TECH.aws_lambda */.O.aws_lambda,
            tech_stack/* TECH.axios */.O.axios,
            tech_stack/* TECH.vend */.O.vend
        ],
        year: "2020",
        description: "A custom integration to collect & update customer information for OmniSend email marketing, utilizing in-store (via QR code) and online sign-ups.",
        featuredImage: Shopify_Vend_Omnisend
    }, 
];

;// CONCATENATED MODULE: ./components/sections/portfolio-preview.tsx












var PortfolioPreview = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)("All Projects"), filter = ref[0], setFilter = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        id: "portfolio",
        className: "portfolio-preview mb-24 min-h-full spacing-4",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                className: "mx-auto grid w-full max-w-6xl px-4 md:px-8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "heading-pre",
                        children: PORTFOLIO.pre
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "heading-2xl -ml-1",
                        children: PORTFOLIO.heading
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "relative -mx-4 overflow-x-auto px-4 pb-2",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("fieldset", {
                            className: "flex gap-3",
                            onChange: function(e) {
                                return setFilter(e.target.value);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("legend", {
                                    className: "sr-only",
                                    children: "Filter by Tag"
                                }),
                                [
                                    "All Projects"
                                ].concat((0,_to_consumable_array/* default */.Z)(new Set(PROJECTS.map(function(p) {
                                    return p.type;
                                }).flat()))).map(function(type, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        className: "flex",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                type: "radio",
                                                className: "peer hidden",
                                                defaultChecked: index === 0,
                                                name: "Tag Filter",
                                                value: type
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "cursor-pointer appearance-none whitespace-nowrap rounded-full border border-gray-200 bg-gray-400/10 py-1 px-3 text-[13px] font-medium text-gray-400 transition-colors peer-checked:text-gray-900 hfa:text-gray-500 d:border-gray-700 d:peer-checked:text-gray-50 d:hfa:text-gray-300",
                                                children: type
                                            })
                                        ]
                                    }, type);
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ScrollGallery, {
                itemWidth: 340,
                gapWidth: 32,
                filter: filter,
                children: PROJECTS.map(function(project, index) {
                    var ref;
                    var rotationIndex = PROJECTS.filter(function(param) {
                        var type = param.type;
                        return filter === "All Projects" || type.includes(filter);
                    }).findIndex(function(param) {
                        var name = param.name;
                        return project.name === name;
                    });
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (0,clsx_m/* default */.Z)("relative h-[380px] w-[340px] min-w-[340px] snap-start rounded-xl border-2 border-gray-700/30 bg-clip-padding p-4 shadow-xl transition-[min-width,width,margin-left,opacity] duration-300 spacing-0 d:border-white/20", filter === "All Projects" || project.type.includes(filter) ? "flex" : "-ml-8 !w-0 !min-w-0 !overflow-hidden !border-0 !px-0 opacity-20", rotationIndex % 2 === 0 && "sm:rotate-[1.5deg]", rotationIndex % 2 === 1 && "sm:rotate-[-1.5deg]", index % 8 === 0 && "shadow-[currentBg] bg-[linear-gradient(40deg,var(--tw-gradient-stops))] from-pink-300/80 to-violet-500/40 shadow-violet-500/20", index % 8 === 1 && "bg-[linear-gradient(120deg,var(--tw-gradient-stops))] from-yellow-300/80 to-rose-600/80 shadow-rose-600/20", index % 8 === 2 && "bg-[linear-gradient(180deg,var(--tw-gradient-stops))] from-gray-200/40 to-rose-500/80 shadow-rose-500/20", index % 8 === 3 && "bg-[linear-gradient(120deg,var(--tw-gradient-stops))] from-green-400/70 to-cyan-600/80 shadow-cyan-600/20", index % 8 === 4 && "bg-[linear-gradient(140deg,var(--tw-gradient-stops))] from-orange-500/50 to-yellow-500/80 shadow-yellow-500/20", index % 8 === 5 && "bg-[linear-gradient(200deg,var(--tw-gradient-stops))] from-purple-500/80 to-sky-600/40 shadow-sky-600/20", index % 8 === 6 && "bg-[linear-gradient(70deg,var(--tw-gradient-stops))] from-emerald-400/80 to-teal-600/40 shadow-teal-600/20", index % 8 === 7 && "bg-[linear-gradient(140deg,var(--tw-gradient-stops))] from-cyan-400/80 to-indigo-700/50 shadow-indigo-700/20"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("figure", {
                                className: "relative flex aspect-2 w-full",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_image/* Image */.E, {
                                    preload: true,
                                    src: project.featuredImage,
                                    alt: project.name,
                                    width: 400,
                                    height: 200,
                                    maxWidth: 320,
                                    className: "rounded-t-lg object-cover object-center [mask-image:linear-gradient(180deg,#fff_16.35%,rgb(255_255_255_/_0%)_91.66%)]"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                        className: "text-2xl font-bold tracking-tighter text-gray-800 d:text-white",
                                        children: project.name
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mt-0.5 -ml-0.5 flex items-center gap-2 tracking-tight text-gray-600 d:text-gray-200",
                                        children: (ref = project.tech) === null || ref === void 0 ? void 0 : ref.map(function(param, i) {
                                            var name = param.name, Icon = param.Icon;
                                            if (i > 3) return null;
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex select-none items-center gap-1 whitespace-nowrap rounded border border-gray-700/10 bg-gray-200/30 py-[2px] px-1.5 text-[13px] font-medium hfa:bg-gray-200/60 d:bg-gray-900/20 d:text-gray-50/80 d:hfa:bg-gray-900/30",
                                                children: name
                                            }, name);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                                className: "mt-2 text-[15px] tracking-tight text-gray-600 d:text-gray-200 ",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                    className: "line-clamp-4",
                                    children: project.description
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
                                className: "absolute bottom-3 left-0 mt-auto flex w-full items-end justify-end gap-2 px-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "mr-auto text-sm font-semibold text-gray-700/80 d:text-gray-300/80",
                                        children: project.year
                                    }),
                                    project.repository ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        target: "_blank",
                                        href: project.repository,
                                        className: "p-1 text-gray-700/80 transition-all hfa:text-gray-900 d:text-gray-300/80 d:hfa:text-gray-50",
                                        "data-tip": "View repository",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Link to Github repository"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGithub/* FaGithub */.h, {
                                                className: "h-5 w-5 "
                                            })
                                        ]
                                    }) : null,
                                    project.url ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components_link/* Link */.r, {
                                        target: "_blank",
                                        href: project.url,
                                        className: "p-1 text-gray-700/80 transition-all hfa:text-gray-900 d:text-gray-300/80 d:hfa:text-gray-50",
                                        "data-tip": "View site",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "sr-only",
                                                children: "Link to Project"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkIcon/* default */.Z, {
                                                className: "h-5 w-5 "
                                            })
                                        ]
                                    }) : null
                                ]
                            })
                        ]
                    }, project.name);
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/_hooks/use-debounce-effect.tsx


var useDebouncedEffect = function(effect, delay, deps) {
    (0,react.useEffect)(function() {
        var handler = setTimeout(function() {
            return effect();
        }, delay);
        return function() {
            return clearTimeout(handler);
        };
    // using || operator because
    // if its optional then it can be undefined.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, (0,_to_consumable_array/* default */.Z)(deps || []).concat([
        delay
    ]));
};

// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/esm/StarIcon.js
var esm_StarIcon = __webpack_require__(89227);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/WifiIcon.js
var WifiIcon = __webpack_require__(912);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ComputerDesktopIcon.js
var ComputerDesktopIcon = __webpack_require__(44542);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/CodeBracketIcon.js
var CodeBracketIcon = __webpack_require__(17551);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/CodeBracketSquareIcon.js
var CodeBracketSquareIcon = __webpack_require__(35152);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/LanguageIcon.js
var LanguageIcon = __webpack_require__(63933);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/BookOpenIcon.js
var BookOpenIcon = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/UserCircleIcon.js
var UserCircleIcon = __webpack_require__(55499);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/ChartBarIcon.js
var ChartBarIcon = __webpack_require__(49773);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/FireIcon.js
var FireIcon = __webpack_require__(93062);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/24/solid/esm/BuildingOffice2Icon.js
var BuildingOffice2Icon = __webpack_require__(60721);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ai/AiOutlineDollar.js
var AiOutlineDollar = __webpack_require__(16514);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bi/BiGame.js
var BiGame = __webpack_require__(73874);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/bi/BiSticker.js
var BiSticker = __webpack_require__(77386);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaBaby.js
var FaBaby = __webpack_require__(64786);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaChalkboardTeacher.js
var FaChalkboardTeacher = __webpack_require__(49870);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaGraduationCap.js
var FaGraduationCap = __webpack_require__(73881);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaPlaneDeparture.js
var FaPlaneDeparture = __webpack_require__(77280);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaQuestion.js
var FaQuestion = __webpack_require__(71474);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaTruck.js
var FaTruck = __webpack_require__(89843);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/fa/FaTruckMoving.js
var FaTruckMoving = __webpack_require__(15069);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gi/GiAfrica.js
var GiAfrica = __webpack_require__(53812);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gi/GiBigDiamondRing.js
var GiBigDiamondRing = __webpack_require__(22029);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gi/GiOppositeHearts.js
var GiOppositeHearts = __webpack_require__(18410);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gi/GiShipBow.js
var GiShipBow = __webpack_require__(47162);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gi/GiSoccerBall.js
var GiSoccerBall = __webpack_require__(11336);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gi/GiSouthAfrica.js
var GiSouthAfrica = __webpack_require__(48011);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gi/GiSuspensionBridge.js
var GiSuspensionBridge = __webpack_require__(14461);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/gr/GrRestaurant.js
var GrRestaurant = __webpack_require__(42133);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/io/IoMdRestaurant.js
var IoMdRestaurant = __webpack_require__(71076);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiVirusLine.js
var RiVirusLine = __webpack_require__(77843);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/ri/RiWalkFill.js
var RiWalkFill = __webpack_require__(34681);
// EXTERNAL MODULE: ./node_modules/@react-icons/all-files/si/SiCoronaengine.js
var SiCoronaengine = __webpack_require__(20059);
;// CONCATENATED MODULE: ./content/timeline.tsx


























var TIMELINEOBJECT = {
    "1986": [
        {
            date: "1986-01-08",
            heading: "Born",
            description: "In Viersen Germany, a few days early.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaBaby/* FaBaby */.x, {
                    className: className
                });
            }
        }, 
    ],
    "1996": [
        {
            date: "1996-06-01",
            heading: "Online",
            description: "I was fortunate to explore the internet at the age of 10 using a 28.9KBit modem. I was absolutely mind blown \uD83E\uDD2F",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(WifiIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "1997": [
        {
            date: "1997-01-01",
            heading: "First Computer",
            description: "My brother and I were building our first computer from scratch, using my stepdads old hardware and buying some new components. 133Mhz Pentium with 8mb ram \uD83D\uDE02",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComputerDesktopIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "1997-06-01",
            heading: "First line of code",
            description: "My stepdad Franz thought me programming ⌨, building a calculator \uD83E\uDDEE and a racing game \uD83D\uDC7E \uD83C\uDFCE with Delphi and Pascal",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "1999": [
        {
            date: "1999-01-01",
            heading: "Visit to SF",
            description: "Exploring the tech world as a teenager. I bought a brand new Laser Mouse \uD83D\uDDB1 at the Metreon downtown San Fransisco.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiSuspensionBridge/* GiSuspensionBridge */.B, {
                    className: className
                });
            }
        },
        {
            date: "1999-05-01",
            heading: "Gaming",
            description: "I got into Gaming \uD83D\uDD79 and Lan Parties, playing Half-life, Diablo I & StarCraft (when not struggling to setup the 10MBit network)",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BiGame/* BiGame */.g, {
                    className: className
                });
            }
        }, 
    ],
    "2000": [
        {
            date: "2000-01-01",
            heading: "Web development",
            description: "I build my first websites using MS FrontPage 98. Anyone remembers Frames? \uD83D\uDE43",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketSquareIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2001": [
        {
            date: "2001-01-01",
            heading: "Game Modding",
            description: "I got into game Modding and started experimenting, mostly with Counter Strike & the HL engine.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiCoronaengine/* SiCoronaengine */.u, {
                    className: className
                });
            }
        }, 
    ],
    "2002": [
        {
            date: "2002-01-01",
            heading: "First Visit to SA",
            description: "I went to South Africa for the first time, visiting St Francis Bay on the Garden Route.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiAfrica/* GiAfrica */.s, {
                    className: className
                });
            }
        }, 
    ],
    "2004": [
        {
            date: "2004-01-01",
            heading: "Graduated High School",
            description: "I completed my last three years at a High-school for Technology and Media in Germany and shortly after found myself working different jobs, trying to figure out what I wanted to do.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGraduationCap/* FaGraduationCap */.n, {
                    className: className
                });
            }
        }, 
    ],
    "2005": [
        {
            date: "2005-01-01",
            heading: "Lost Teenager",
            description: "After High school, I was totally lost in direction, thinking that my skills in game modding/web dev weren't any useful.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaQuestion/* FaQuestion */.g, {
                    className: className
                });
            }
        }, 
    ],
    "2006": [
        {
            date: "2006-01-01",
            heading: "Second visit to SA",
            description: "I visited South Africa for the second time. This time, exploring Cape Town and I totally fell in love with it.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiSouthAfrica/* GiSouthAfrica */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2007": [
        {
            date: "2007-01-01",
            heading: "Planning my Career",
            description: "This was a big step for me at the age of 21. I decided to take on a different career path, jumping straight into my other passion for food & hospitality, leaving the tech world as a hobby.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GrRestaurant/* GrRestaurant */.a, {
                    className: className
                });
            }
        },
        {
            date: "2007-05-01",
            heading: "Move to South Africa",
            description: "I decided to pack up my things in Germany and start my Career in Hospitality in Cape Town, to gain international experience. ",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaPlaneDeparture/* FaPlaneDeparture */.j, {
                    className: className
                });
            }
        },
        {
            date: "2007-08-01",
            heading: "Learning English",
            description: "I took a deep dive into learning English within 3 months in South Africa, going from hating languages to 100% native.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2008": [
        {
            date: "2008-01-01",
            heading: "Short-term Study",
            description: "I started at the International Hotel School for a 6 month adjustment course.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGraduationCap/* FaGraduationCap */.n, {
                    className: className
                });
            }
        },
        {
            date: "2008-06-01",
            heading: "Germany vs South Africa",
            description: "I moved back to Germany in july 2008, to start an apprenticeship as a Chef.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaPlaneDeparture/* FaPlaneDeparture */.j, {
                    className: className
                });
            }
        },
        {
            date: "2008-09-01",
            heading: "Financial Crisis",
            description: "My apprenticeship was cut short, as the establishment closed down as retrenching all apprentices as the Financial crisis hit Germany.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GrRestaurant/* GrRestaurant */.a, {
                    className: className
                });
            }
        }, 
    ],
    "2009": [
        {
            date: "2009-01-01",
            heading: "Full-time Study",
            description: "I once again, moved back to South Africa. This time to stay for at least 3 years to study Cheffing & Hospitality full-time.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BookOpenIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2010": [
        {
            date: "2010-01-01",
            heading: "World Cup 2010",
            description: "It was amazing to be in Cape Town during the World Cup 2010 in SA. Germany vs Argentina - 4:0",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiSoccerBall/* GiSoccerBall */.I, {
                    className: className
                });
            }
        }, 
    ],
    "2011": [
        {
            date: "2011-09-01",
            heading: "Working on Cruise Line",
            description: "Spend 4 months traveling the seas onboard of the Yachts of Seabourn. Visited many countries in North America & The Caribbean while working as a Waiter.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiShipBow/* GiShipBow */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2012": [
        {
            date: "2012-06-01",
            heading: "Graduated Varsity",
            description: "I graduated with three Higher National Diplomas Summa Cum Laude, covering all aspects I needed to know to one day open my own restaurant",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGraduationCap/* FaGraduationCap */.n, {
                    className: className
                });
            }
        },
        {
            date: "2012-06-01",
            heading: "Getting into Management",
            description: "I started as a waiter and got promoted shortly after to Assistant Restaurant Manager at Salt Restaurant. Developing some great connections.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCircleIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2013": [
        {
            date: "2013-06-01",
            heading: "Kitima Restaurant",
            description: "Joined the Best Asian Restaurant in South Africa as a Restaurant Manager overseeing a team of 50 employees.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IoMdRestaurant/* IoMdRestaurant */.I, {
                    className: className
                });
            }
        },
        {
            date: "2013-09-01",
            heading: "Training & Development",
            description: "I took on a specialized role focusing on training & development of the team to reach their full potential.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaChalkboardTeacher/* FaChalkboardTeacher */.F, {
                    className: className
                });
            }
        }, 
    ],
    "2014": [
        {
            date: "2014-01-01",
            heading: "Reconnecting the dots",
            description: "I was exposed to a lot of IT & Web dev work for the restaurant. I reconnected a lot of my teenage skill with IT and learned more about POS systems.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiOppositeHearts/* GiOppositeHearts */.U, {
                    className: className
                });
            }
        },
        {
            date: "2014-06-01",
            heading: "Personal Website",
            description: "I decided to build my site with WordPress, showing a gallery and info about me. Unfortunately, I didn't use Git yet and lost the source code on a old HDD.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComputerDesktopIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2015": [
        {
            date: "2015-01-01",
            heading: "Restaurant Consultant",
            description: "I left my full-time position early in 2015 to focus on a Postgraduate diploma at UCT. I continued my work in a Consulting Role.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserCircleIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2015-03-01",
            heading: "Co-founded SimplyStuck",
            description: "Started a Vinyl sticker business, while exploring the very interesting customer segment of students \uD83D\uDC68‍ \uD83C\uDF93 It was part study, part real business, but somehow eventually faded & failed as we had a team of 6 co-founders. Stick to 1 or 2 if you can. \uD83D\uDE09",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BiSticker/* BiSticker */.L, {
                    className: className
                });
            }
        },
        {
            date: "2015-05-01",
            heading: "Got Engaged",
            description: "I asked my then girlfriend, Elizabeth, to marry me. She said yes! I took her out for a super romantic dinner and popped the question in a full restaurant.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiBigDiamondRing/* GiBigDiamondRing */.Q, {
                    className: className
                });
            }
        },
        {
            date: "2015-08-01",
            heading: "Graduated Postgraduate at UCT",
            description: "I went back to University in 2015 to advance with a Postgraduate Diploma in Business Management & Entrepreneurship. \uD83D\uDCDA \uD83D\uDC53",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaGraduationCap/* FaGraduationCap */.n, {
                    className: className
                });
            }
        },
        {
            date: "2015-12-01",
            heading: "Got Married",
            description: "If this Year wasn't enough. Liz and I decided to have a small ceremony with the closes friends & family at a beautiful wine farm in Cape Town.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiBigDiamondRing/* GiBigDiamondRing */.Q, {
                    className: className
                });
            }
        }, 
    ],
    "2016": [
        {
            date: "2016-01-01",
            heading: "Opening a Restaurant",
            description: "After graduation, I got straight back to work. This time as General Manager, opening a brand new Restaurant in Cape Town (for a private investor)",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IoMdRestaurant/* IoMdRestaurant */.I, {
                    className: className
                });
            }
        },
        {
            date: "2016-03-01",
            heading: "Project Management & IT",
            description: "I opened Raya Kitchen over 2 months including construction and hiring a new team from scratch, and setting the POS & IT operations.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartBarIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2016-06-01",
            heading: "Coding Skills",
            description: "I pursued my interests in web development & tech professionally. I did a deep dive completing the FreeCodeCamp Front-end & Back-end Certifications.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2016-06-01",
            heading: "Tech + Restaurant",
            description: "I started Smart-up Online. An online training platform/SaaS for restaurant owners & managers to train their staff.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_StarIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2017": [
        {
            date: "2017-05-01",
            heading: "Food Truck, almost.",
            description: "My Wife and I were both getting excited to start our own Food Truck and planned out all the details. However, the stars were not aligned for it. We shall get back to it!!",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaTruck/* FaTruck */.H, {
                    className: className
                });
            }
        },
        {
            date: "2017-06-01",
            heading: "Full-time Web Development",
            description: "I found my first clients to work on the side, which quickly grew to full-time freelancing occupation, where I got hooked on React.js",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2017-08-01",
            heading: "Shopify Dev",
            description: "Partnered up to start a small Shopify E-commerce web design studio.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiShopify/* SiShopify */.F, {
                    className: className
                });
            }
        }, 
    ],
    "2018": [
        {
            date: "2018-01-01",
            heading: "First Custom Project",
            description: "I've built AlphabetPIX for a client as my first web-app, learning tons on a new tech domain.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketSquareIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2018-02-01",
            heading: "Move to Knysna",
            description: "My Wife and I made the decision to move to Knysna on the Garden Route to open a Restaurant.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FaTruckMoving/* FaTruckMoving */.s, {
                    className: className
                });
            }
        },
        {
            date: "2018-05-01",
            heading: "Start-up Funding",
            description: "The first experience acquiring start-up funding for our restaurant. You gotta move early and fast, as everyone else will slow you down.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(AiOutlineDollar/* AiOutlineDollar */.L, {
                    className: className
                });
            }
        },
        {
            date: "2018-05-01",
            heading: "The Burger Exchange",
            description: "Its always been a dream Now we took the steps to make it a reality. A 200 seater Restaurant with our own concept of a trendy upmarket Burger Joint.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IoMdRestaurant/* IoMdRestaurant */.I, {
                    className: className
                });
            }
        }, 
    ],
    "2019": [
        {
            date: "2019-05-01",
            heading: "Namibia Holidays",
            description: "We survived our first holiday season at the restaurant and took a one week holiday which was simply mind blowing.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GiAfrica/* GiAfrica */.s, {
                    className: className
                });
            }
        },
        {
            date: "2019-05-01",
            heading: "Restaurant Upgrade",
            description: "We upgraded the concept to the fit market environment & shifted focus to also include a variety of wood fired grills. \uD83E\uDD69\uD83D\uDD25",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(IoMdRestaurant/* IoMdRestaurant */.I, {
                    className: className
                });
            }
        },
        {
            date: "2019-05-01",
            heading: "Smart-Up 2.0",
            description: "I took a data driven approach to create new training material for Smart-Up Online, and to use internally at the restaurant. Including a deep dive into MySQL & Oracle DB.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(FireIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2020": [
        {
            date: "2020-01-01",
            heading: "Season 2",
            description: "We grew the restaurant consistently, with the best season and a blast of a staff party to finish off the holiday times.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ChartBarIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2020-02-01",
            heading: "Covid 19",
            description: "From a successful restaurant to closing our doors in a matter of weeks. Its been a great journey, the uncertainty of corona and the lockdown have clarified major life-changing questions. Answering them became easy overnight.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RiVirusLine/* RiVirusLine */.c, {
                    className: className
                });
            }
        },
        {
            date: "2020-04-01",
            heading: "Back to Web Dev",
            description: "I restarted my freelancing Web dev and got back in touch with clients, jumping into the booming ecommerce train.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2020-07-01",
            heading: "felixtellmann.com",
            description: "Finally after a few months of design & redesigns, and other projects in the background, I got my new (now old) page up and running.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComputerDesktopIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2021": [
        {
            date: "2021-01-01",
            heading: "Dev tools",
            description: "I created created and maintain two open source dev tools: fx-style and shopify-ftp-access.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketSquareIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2021-04-01",
            heading: "Otter Trail",
            description: "I went on a 5 day adventure hike carrying 15kg of gear & provisions for 45km on the Garden Route",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(RiWalkFill/* RiWalkFill */.c, {
                    className: className
                });
            }
        },
        {
            date: "2021-06-01",
            heading: "New Office",
            description: "We moved into our new office on Bree street with a stunning balcony and some great neighbours.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(BuildingOffice2Icon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2021-08-01",
            heading: "ClickUpload",
            description: "I lead the creation of ClickUpload, a public Shopify app that allows users to upload files with their orders.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiShopify/* SiShopify */.F, {
                    className: className
                });
            }
        },
        {
            date: "2021-11-01",
            heading: "shopify-typed-node-api",
            description: "I upgraded shopify-node-api to be fully typesafe and published it as an alternative to the non TS version.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2021-02-01",
            heading: "Backend API integrations",
            description: "Over the year I got heavily involved in some backend custom integrations, building solutions with AWS for our clients.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_StarIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ],
    "2022": [
        {
            date: "2022-01-01",
            heading: "Lunalemon",
            description: "We've launched LunaLemon as a brand to reach a more international audience for app & headless ecommerce solutions.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(ComputerDesktopIcon/* default */.Z, {
                    className: className
                });
            }
        },
        {
            date: "2022-02-01",
            heading: "LunaTag",
            description: "The second Shopify App that's published in the App store allows marchants to Tag their product on any image on their store.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(SiShopify/* SiShopify */.F, {
                    className: className
                });
            }
        },
        {
            date: "2022-02-01",
            heading: "Shopify-cms",
            description: "I always wanted to create a Shopify Theme that was fully React based, I finally figured it out and build shopify-cms along the way.",
            Icon: function(param) {
                var _className = param.className, className = _className === void 0 ? "" : _className;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(CodeBracketSquareIcon/* default */.Z, {
                    className: className
                });
            }
        }, 
    ]
};

// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(17037);
;// CONCATENATED MODULE: ./components/sections/timeline.tsx









var Timeline = function(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    var ref = (0,react.useState)(""), selected = ref[0], setSelected = ref[1];
    var ref1 = (0,react.useState)(false), initiated = ref1[0], setInitiated = ref1[1];
    var scrollContainerRef = (0,react.useRef)(null);
    var ref2 = (0,react.useState)(true), autoAnimate = ref2[0], setAutoAnimate = ref2[1];
    var ref3 = (0,react.useState)(true), autoScroll = ref3[0], setAutoScroll = ref3[1];
    var inView = (0,use_in_view/* useInView */.Y)(scrollContainerRef);
    (0,react.useEffect)(function() {
        if (!initiated && inView) {
            var container = scrollContainerRef.current;
            setTimeout(function() {
                var year = Object.keys(TIMELINEOBJECT)[0];
                setInitiated(true);
                setSelected("".concat(year, "-", 0));
            }, 50);
        }
    }, [
        inView,
        initiated
    ]);
    useDebouncedEffect(function() {
        var ref;
        if (!autoScroll || !inView) return;
        var ref1 = (0,_sliced_to_array/* default */.Z)(selected.split("-"), 2), year = ref1[0], index = ref1[1];
        var keys = Object.keys(TIMELINEOBJECT);
        var values = Object.values(TIMELINEOBJECT);
        var yearLength = keys.length;
        var yearIndex = keys.findIndex(function(key) {
            return key === year;
        });
        var indexLength = (ref = TIMELINEOBJECT[year]) === null || ref === void 0 ? void 0 : ref.length;
        var totalIndex = values.flat().findIndex(function(val) {
            return new Date(val.date).getFullYear() === +year;
        }) + +index;
        var container = scrollContainerRef.current;
        if (yearIndex + 1 === yearLength && +index + 1 === indexLength) return;
        var scrollTarget = totalIndex * 120;
        if (container.scrollLeft > scrollTarget - 120 || scrollTarget > container.scrollLeft + container.clientWidth - 240) {
            (0,scroll_to/* scrollToX */.T)(200, scrollTarget, container);
        }
        if (+index + 1 !== indexLength) {
            setSelected("".concat(year, "-").concat(+index + 1));
            return;
        }
        if (yearIndex + 1 !== yearLength && +index + 1 === indexLength) {
            setSelected("".concat(keys[yearIndex + 1], "-", 0));
        }
    }, 2400, [
        selected,
        autoScroll,
        inView
    ]);
    useDebouncedEffect(function() {
        setAutoScroll(true);
    }, 10000, [
        autoScroll
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: "mx-auto max-w-6xl px-4 pb-16 md:px-8",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "-mx-4 flex h-96 overflow-x-auto py-4 px-6 xl:mx-0",
            ref: scrollContainerRef,
            children: [
                Object.entries(TIMELINEOBJECT).map(function(param, yearIndex, years) {
                    var _param = (0,_sliced_to_array/* default */.Z)(param, 2), year = _param[0], events = _param[1];
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                                className: "absolute left-0 -translate-x-1/2 select-none text-xs font-semibold text-gray-400",
                                children: year
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mt-6 grid",
                                style: {
                                    gridTemplateColumns: "repeat(".concat(events.length, ", 120px)")
                                },
                                children: events.map(function(param, index) {
                                    var heading = param.heading, Icon = param.Icon, description = param.description;
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                        className: (0,clsx_m/* default */.Z)("relative", selected === "".concat(year, "-").concat(index) && "selected"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                                className: " absolute flex -translate-x-1/2 flex-col items-center px-3 hfa:outline-none",
                                                onMouseOver: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                onPointerOver: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                onFocus: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                onClick: function() {
                                                    setAutoScroll(false);
                                                    setSelected("".concat(year, "-").concat(index));
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "sr-only",
                                                        children: "".concat(year, " - ").concat(heading)
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "h-8 w-0.5 bg-gray-500 transition-all selected:h-[80px] selected:bg-sky-500"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon, {
                                                        className: "mt-2 h-5 w-5 text-gray-500 transition-all d:text-gray-400 selected:text-gray-900 d:selected:text-white"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "absolute top-0 left-px h-2.5 w-[119px] bg-[image:linear-gradient(90deg,transparent_0px,transparent_9px,var(--line-color)_10px,var(--line-color)_10px)] bg-[length:10px_10px] [--line-color:theme(colors.gray.500)]"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
                                                className: (0,clsx_m/* default */.Z)("pointer-events-none relative mt-32 w-[17rem] opacity-0 transition-opacity  selected:pointer-events-auto selected:opacity-100", yearIndex === 0 && index === 0 ? "" : "-translate-x-1/2 text-center"),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "whitespace-nowrap font-semibold tracking-tight text-gray-800 d:text-gray-100",
                                                        children: heading
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-[15px] font-medium leading-relaxed tracking-tight text-gray-500",
                                                        children: description
                                                    })
                                                ]
                                            })
                                        ]
                                    }, heading);
                                })
                            })
                        ]
                    }, year);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("header", {
                            className: "absolute left-0 -translate-x-1/2 text-xs font-semibold text-gray-400",
                            children: "Today"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "mt-6",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                className: "relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "h-8 w-0.5 bg-gray-500 pb-4"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./pages/index.tsx






(lib_default()).settings.respectReducedMotion = false;
var __N_SSG = true;
var Index = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero, {
                twitterData: props.twitterData
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(About, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Timeline, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PortfolioPreview, {})
        ]
    });
};
/* harmony default export */ var pages = (Index);


/***/ }),

/***/ 96316:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./prism-abap": [
		86405,
		86405
	],
	"./prism-abap.js": [
		86405,
		86405
	],
	"./prism-abap.min": [
		7062,
		7062
	],
	"./prism-abap.min.js": [
		7062,
		7062
	],
	"./prism-abnf": [
		68758,
		68758
	],
	"./prism-abnf.js": [
		68758,
		68758
	],
	"./prism-abnf.min": [
		48121,
		48121
	],
	"./prism-abnf.min.js": [
		48121,
		48121
	],
	"./prism-actionscript": [
		35249,
		35249
	],
	"./prism-actionscript.js": [
		35249,
		35249
	],
	"./prism-actionscript.min": [
		53896,
		53896
	],
	"./prism-actionscript.min.js": [
		53896,
		53896
	],
	"./prism-ada": [
		85795,
		85795
	],
	"./prism-ada.js": [
		85795,
		85795
	],
	"./prism-ada.min": [
		92497,
		92497
	],
	"./prism-ada.min.js": [
		92497,
		92497
	],
	"./prism-agda": [
		47231,
		47231
	],
	"./prism-agda.js": [
		47231,
		47231
	],
	"./prism-agda.min": [
		14552,
		14552
	],
	"./prism-agda.min.js": [
		14552,
		14552
	],
	"./prism-al": [
		42273,
		42273
	],
	"./prism-al.js": [
		42273,
		42273
	],
	"./prism-al.min": [
		47347,
		47347
	],
	"./prism-al.min.js": [
		47347,
		47347
	],
	"./prism-antlr4": [
		44852,
		44852
	],
	"./prism-antlr4.js": [
		44852,
		44852
	],
	"./prism-antlr4.min": [
		5527,
		5527
	],
	"./prism-antlr4.min.js": [
		5527,
		5527
	],
	"./prism-apacheconf": [
		77533,
		77533
	],
	"./prism-apacheconf.js": [
		77533,
		77533
	],
	"./prism-apacheconf.min": [
		24242,
		24242
	],
	"./prism-apacheconf.min.js": [
		24242,
		24242
	],
	"./prism-apex": [
		72594,
		72594
	],
	"./prism-apex.js": [
		72594,
		72594
	],
	"./prism-apex.min": [
		50516,
		50516
	],
	"./prism-apex.min.js": [
		50516,
		50516
	],
	"./prism-apl": [
		18508,
		18508
	],
	"./prism-apl.js": [
		18508,
		18508
	],
	"./prism-apl.min": [
		38162,
		38162
	],
	"./prism-apl.min.js": [
		38162,
		38162
	],
	"./prism-applescript": [
		31093,
		31093
	],
	"./prism-applescript.js": [
		31093,
		31093
	],
	"./prism-applescript.min": [
		39943,
		39943
	],
	"./prism-applescript.min.js": [
		39943,
		39943
	],
	"./prism-aql": [
		25691,
		25691
	],
	"./prism-aql.js": [
		25691,
		25691
	],
	"./prism-aql.min": [
		29846,
		29846
	],
	"./prism-aql.min.js": [
		29846,
		29846
	],
	"./prism-arduino": [
		51849,
		51849
	],
	"./prism-arduino.js": [
		51849,
		51849
	],
	"./prism-arduino.min": [
		71335,
		71335
	],
	"./prism-arduino.min.js": [
		71335,
		71335
	],
	"./prism-arff": [
		73253,
		73253
	],
	"./prism-arff.js": [
		73253,
		73253
	],
	"./prism-arff.min": [
		13955,
		13955
	],
	"./prism-arff.min.js": [
		13955,
		13955
	],
	"./prism-armasm": [
		24029,
		24029
	],
	"./prism-armasm.js": [
		24029,
		24029
	],
	"./prism-armasm.min": [
		87809,
		87809
	],
	"./prism-armasm.min.js": [
		87809,
		87809
	],
	"./prism-arturo": [
		2481,
		2481
	],
	"./prism-arturo.js": [
		2481,
		2481
	],
	"./prism-arturo.min": [
		53566,
		53566
	],
	"./prism-arturo.min.js": [
		53566,
		53566
	],
	"./prism-asciidoc": [
		10856,
		10856
	],
	"./prism-asciidoc.js": [
		10856,
		10856
	],
	"./prism-asciidoc.min": [
		55692,
		55692
	],
	"./prism-asciidoc.min.js": [
		55692,
		55692
	],
	"./prism-asm6502": [
		36972,
		36972
	],
	"./prism-asm6502.js": [
		36972,
		36972
	],
	"./prism-asm6502.min": [
		68409,
		68409
	],
	"./prism-asm6502.min.js": [
		68409,
		68409
	],
	"./prism-asmatmel": [
		36430,
		36430
	],
	"./prism-asmatmel.js": [
		36430,
		36430
	],
	"./prism-asmatmel.min": [
		40802,
		40802
	],
	"./prism-asmatmel.min.js": [
		40802,
		40802
	],
	"./prism-aspnet": [
		54019,
		54019
	],
	"./prism-aspnet.js": [
		54019,
		54019
	],
	"./prism-aspnet.min": [
		54780,
		54780
	],
	"./prism-aspnet.min.js": [
		54780,
		54780
	],
	"./prism-autohotkey": [
		92776,
		92776
	],
	"./prism-autohotkey.js": [
		92776,
		92776
	],
	"./prism-autohotkey.min": [
		531,
		531
	],
	"./prism-autohotkey.min.js": [
		531,
		531
	],
	"./prism-autoit": [
		24940,
		24940
	],
	"./prism-autoit.js": [
		24940,
		24940
	],
	"./prism-autoit.min": [
		20021,
		20021
	],
	"./prism-autoit.min.js": [
		20021,
		20021
	],
	"./prism-avisynth": [
		58060,
		58060
	],
	"./prism-avisynth.js": [
		58060,
		58060
	],
	"./prism-avisynth.min": [
		51508,
		51508
	],
	"./prism-avisynth.min.js": [
		51508,
		51508
	],
	"./prism-avro-idl": [
		639,
		639
	],
	"./prism-avro-idl.js": [
		639,
		639
	],
	"./prism-avro-idl.min": [
		9156,
		9156
	],
	"./prism-avro-idl.min.js": [
		9156,
		9156
	],
	"./prism-awk": [
		84126,
		84126
	],
	"./prism-awk.js": [
		84126,
		84126
	],
	"./prism-awk.min": [
		91595,
		91595
	],
	"./prism-awk.min.js": [
		91595,
		91595
	],
	"./prism-bash": [
		57874,
		57874
	],
	"./prism-bash.js": [
		57874,
		57874
	],
	"./prism-bash.min": [
		87013,
		87013
	],
	"./prism-bash.min.js": [
		87013,
		87013
	],
	"./prism-basic": [
		94446,
		94446
	],
	"./prism-basic.js": [
		94446,
		94446
	],
	"./prism-basic.min": [
		47098,
		47098
	],
	"./prism-basic.min.js": [
		47098,
		47098
	],
	"./prism-batch": [
		53292,
		53292
	],
	"./prism-batch.js": [
		53292,
		53292
	],
	"./prism-batch.min": [
		65965,
		65965
	],
	"./prism-batch.min.js": [
		65965,
		65965
	],
	"./prism-bbcode": [
		46428,
		46428
	],
	"./prism-bbcode.js": [
		46428,
		46428
	],
	"./prism-bbcode.min": [
		22661,
		22661
	],
	"./prism-bbcode.min.js": [
		22661,
		22661
	],
	"./prism-bbj": [
		27308,
		27308
	],
	"./prism-bbj.js": [
		27308,
		27308
	],
	"./prism-bbj.min": [
		8943,
		8943
	],
	"./prism-bbj.min.js": [
		8943,
		8943
	],
	"./prism-bicep": [
		86043,
		86043
	],
	"./prism-bicep.js": [
		86043,
		86043
	],
	"./prism-bicep.min": [
		74477,
		74477
	],
	"./prism-bicep.min.js": [
		74477,
		74477
	],
	"./prism-birb": [
		69104,
		69104
	],
	"./prism-birb.js": [
		69104,
		69104
	],
	"./prism-birb.min": [
		16997,
		16997
	],
	"./prism-birb.min.js": [
		16997,
		16997
	],
	"./prism-bison": [
		97861,
		97861
	],
	"./prism-bison.js": [
		97861,
		97861
	],
	"./prism-bison.min": [
		41248,
		41248
	],
	"./prism-bison.min.js": [
		41248,
		41248
	],
	"./prism-bnf": [
		24115,
		24115
	],
	"./prism-bnf.js": [
		24115,
		24115
	],
	"./prism-bnf.min": [
		86751,
		86751
	],
	"./prism-bnf.min.js": [
		86751,
		86751
	],
	"./prism-bqn": [
		50331,
		50331
	],
	"./prism-bqn.js": [
		50331,
		50331
	],
	"./prism-bqn.min": [
		60876,
		60876
	],
	"./prism-bqn.min.js": [
		60876,
		60876
	],
	"./prism-brainfuck": [
		15827,
		15827
	],
	"./prism-brainfuck.js": [
		15827,
		15827
	],
	"./prism-brainfuck.min": [
		99676,
		99676
	],
	"./prism-brainfuck.min.js": [
		99676,
		99676
	],
	"./prism-brightscript": [
		21275,
		21275
	],
	"./prism-brightscript.js": [
		21275,
		21275
	],
	"./prism-brightscript.min": [
		39455,
		39455
	],
	"./prism-brightscript.min.js": [
		39455,
		39455
	],
	"./prism-bro": [
		76609,
		76609
	],
	"./prism-bro.js": [
		76609,
		76609
	],
	"./prism-bro.min": [
		28708,
		28708
	],
	"./prism-bro.min.js": [
		28708,
		28708
	],
	"./prism-bsl": [
		61354,
		61354
	],
	"./prism-bsl.js": [
		61354,
		61354
	],
	"./prism-bsl.min": [
		29402,
		29402
	],
	"./prism-bsl.min.js": [
		29402,
		29402
	],
	"./prism-c": [
		4279,
		4279
	],
	"./prism-c.js": [
		4279,
		4279
	],
	"./prism-c.min": [
		36551,
		36551
	],
	"./prism-c.min.js": [
		36551,
		36551
	],
	"./prism-cfscript": [
		86902,
		86902
	],
	"./prism-cfscript.js": [
		86902,
		86902
	],
	"./prism-cfscript.min": [
		45890,
		45890
	],
	"./prism-cfscript.min.js": [
		45890,
		45890
	],
	"./prism-chaiscript": [
		64681,
		64681
	],
	"./prism-chaiscript.js": [
		64681,
		64681
	],
	"./prism-chaiscript.min": [
		55705,
		55705
	],
	"./prism-chaiscript.min.js": [
		55705,
		55705
	],
	"./prism-cil": [
		4677,
		4677
	],
	"./prism-cil.js": [
		4677,
		4677
	],
	"./prism-cil.min": [
		54002,
		54002
	],
	"./prism-cil.min.js": [
		54002,
		54002
	],
	"./prism-cilkc": [
		99114,
		99114
	],
	"./prism-cilkc.js": [
		99114,
		99114
	],
	"./prism-cilkc.min": [
		97298,
		97298
	],
	"./prism-cilkc.min.js": [
		97298,
		97298
	],
	"./prism-cilkcpp": [
		5798,
		5798
	],
	"./prism-cilkcpp.js": [
		5798,
		5798
	],
	"./prism-cilkcpp.min": [
		87850,
		87850
	],
	"./prism-cilkcpp.min.js": [
		87850,
		87850
	],
	"./prism-clike": [
		35433,
		35433
	],
	"./prism-clike.js": [
		35433,
		35433
	],
	"./prism-clike.min": [
		58080,
		58080
	],
	"./prism-clike.min.js": [
		58080,
		58080
	],
	"./prism-clojure": [
		52812,
		52812
	],
	"./prism-clojure.js": [
		52812,
		52812
	],
	"./prism-clojure.min": [
		14821,
		14821
	],
	"./prism-clojure.min.js": [
		14821,
		14821
	],
	"./prism-cmake": [
		44225,
		44225
	],
	"./prism-cmake.js": [
		44225,
		44225
	],
	"./prism-cmake.min": [
		79278,
		79278
	],
	"./prism-cmake.min.js": [
		79278,
		79278
	],
	"./prism-cobol": [
		57649,
		57649
	],
	"./prism-cobol.js": [
		57649,
		57649
	],
	"./prism-cobol.min": [
		42165,
		42165
	],
	"./prism-cobol.min.js": [
		42165,
		42165
	],
	"./prism-coffeescript": [
		46213,
		46213
	],
	"./prism-coffeescript.js": [
		46213,
		46213
	],
	"./prism-coffeescript.min": [
		37271,
		37271
	],
	"./prism-coffeescript.min.js": [
		37271,
		37271
	],
	"./prism-concurnas": [
		29467,
		29467
	],
	"./prism-concurnas.js": [
		29467,
		29467
	],
	"./prism-concurnas.min": [
		2836,
		2836
	],
	"./prism-concurnas.min.js": [
		2836,
		2836
	],
	"./prism-cooklang": [
		25867,
		25867
	],
	"./prism-cooklang.js": [
		25867,
		25867
	],
	"./prism-cooklang.min": [
		35518,
		35518
	],
	"./prism-cooklang.min.js": [
		35518,
		35518
	],
	"./prism-coq": [
		74307,
		74307
	],
	"./prism-coq.js": [
		74307,
		74307
	],
	"./prism-coq.min": [
		68251,
		68251
	],
	"./prism-coq.min.js": [
		68251,
		68251
	],
	"./prism-core": [
		28325,
		28325
	],
	"./prism-core.js": [
		28325,
		28325
	],
	"./prism-core.min": [
		2251,
		2251
	],
	"./prism-core.min.js": [
		2251,
		2251
	],
	"./prism-cpp": [
		2731,
		2731
	],
	"./prism-cpp.js": [
		2731,
		2731
	],
	"./prism-cpp.min": [
		54132,
		54132
	],
	"./prism-cpp.min.js": [
		54132,
		54132
	],
	"./prism-crystal": [
		18980,
		18980
	],
	"./prism-crystal.js": [
		18980,
		18980
	],
	"./prism-crystal.min": [
		77223,
		77223
	],
	"./prism-crystal.min.js": [
		77223,
		77223
	],
	"./prism-csharp": [
		79016,
		79016
	],
	"./prism-csharp.js": [
		79016,
		79016
	],
	"./prism-csharp.min": [
		53229,
		53229
	],
	"./prism-csharp.min.js": [
		53229,
		53229
	],
	"./prism-cshtml": [
		63326,
		63326
	],
	"./prism-cshtml.js": [
		63326,
		63326
	],
	"./prism-cshtml.min": [
		52224,
		33989
	],
	"./prism-cshtml.min.js": [
		52224,
		33989
	],
	"./prism-csp": [
		4412,
		4412
	],
	"./prism-csp.js": [
		4412,
		4412
	],
	"./prism-csp.min": [
		12926,
		12926
	],
	"./prism-csp.min.js": [
		12926,
		12926
	],
	"./prism-css": [
		15251,
		15251
	],
	"./prism-css-extras": [
		80871,
		80871
	],
	"./prism-css-extras.js": [
		80871,
		80871
	],
	"./prism-css-extras.min": [
		61710,
		61710
	],
	"./prism-css-extras.min.js": [
		61710,
		61710
	],
	"./prism-css.js": [
		15251,
		15251
	],
	"./prism-css.min": [
		12247,
		12247
	],
	"./prism-css.min.js": [
		12247,
		12247
	],
	"./prism-csv": [
		97899,
		97899
	],
	"./prism-csv.js": [
		97899,
		97899
	],
	"./prism-csv.min": [
		28341,
		28341
	],
	"./prism-csv.min.js": [
		28341,
		28341
	],
	"./prism-cue": [
		2946,
		2946
	],
	"./prism-cue.js": [
		2946,
		2946
	],
	"./prism-cue.min": [
		99938,
		99938
	],
	"./prism-cue.min.js": [
		99938,
		99938
	],
	"./prism-cypher": [
		30258,
		30258
	],
	"./prism-cypher.js": [
		30258,
		30258
	],
	"./prism-cypher.min": [
		99860,
		99860
	],
	"./prism-cypher.min.js": [
		99860,
		99860
	],
	"./prism-d": [
		58149,
		58149
	],
	"./prism-d.js": [
		58149,
		58149
	],
	"./prism-d.min": [
		3525,
		3525
	],
	"./prism-d.min.js": [
		3525,
		3525
	],
	"./prism-dart": [
		57065,
		57065
	],
	"./prism-dart.js": [
		57065,
		57065
	],
	"./prism-dart.min": [
		80974,
		80974
	],
	"./prism-dart.min.js": [
		80974,
		80974
	],
	"./prism-dataweave": [
		73162,
		73162
	],
	"./prism-dataweave.js": [
		73162,
		73162
	],
	"./prism-dataweave.min": [
		65897,
		65897
	],
	"./prism-dataweave.min.js": [
		65897,
		65897
	],
	"./prism-dax": [
		90827,
		90827
	],
	"./prism-dax.js": [
		90827,
		90827
	],
	"./prism-dax.min": [
		19486,
		19486
	],
	"./prism-dax.min.js": [
		19486,
		19486
	],
	"./prism-dhall": [
		24370,
		24370
	],
	"./prism-dhall.js": [
		24370,
		24370
	],
	"./prism-dhall.min": [
		87981,
		87981
	],
	"./prism-dhall.min.js": [
		87981,
		87981
	],
	"./prism-diff": [
		40728,
		40728
	],
	"./prism-diff.js": [
		40728,
		40728
	],
	"./prism-diff.min": [
		72734,
		72734
	],
	"./prism-diff.min.js": [
		72734,
		72734
	],
	"./prism-django": [
		54409,
		54409
	],
	"./prism-django.js": [
		54409,
		54409
	],
	"./prism-django.min": [
		85534,
		85534
	],
	"./prism-django.min.js": [
		85534,
		85534
	],
	"./prism-dns-zone-file": [
		68483,
		68483
	],
	"./prism-dns-zone-file.js": [
		68483,
		68483
	],
	"./prism-dns-zone-file.min": [
		67659,
		67659
	],
	"./prism-dns-zone-file.min.js": [
		67659,
		67659
	],
	"./prism-docker": [
		77158,
		77158
	],
	"./prism-docker.js": [
		77158,
		77158
	],
	"./prism-docker.min": [
		74280,
		74280
	],
	"./prism-docker.min.js": [
		74280,
		74280
	],
	"./prism-dot": [
		60397,
		60397
	],
	"./prism-dot.js": [
		60397,
		60397
	],
	"./prism-dot.min": [
		26141,
		26141
	],
	"./prism-dot.min.js": [
		26141,
		26141
	],
	"./prism-ebnf": [
		68232,
		68232
	],
	"./prism-ebnf.js": [
		68232,
		68232
	],
	"./prism-ebnf.min": [
		79543,
		79543
	],
	"./prism-ebnf.min.js": [
		79543,
		79543
	],
	"./prism-editorconfig": [
		22456,
		22456
	],
	"./prism-editorconfig.js": [
		22456,
		22456
	],
	"./prism-editorconfig.min": [
		41880,
		41880
	],
	"./prism-editorconfig.min.js": [
		41880,
		41880
	],
	"./prism-eiffel": [
		59979,
		59979
	],
	"./prism-eiffel.js": [
		59979,
		59979
	],
	"./prism-eiffel.min": [
		2891,
		2891
	],
	"./prism-eiffel.min.js": [
		2891,
		2891
	],
	"./prism-ejs": [
		70060,
		70060
	],
	"./prism-ejs.js": [
		70060,
		70060
	],
	"./prism-ejs.min": [
		65823,
		65823
	],
	"./prism-ejs.min.js": [
		65823,
		65823
	],
	"./prism-elixir": [
		68805,
		68805
	],
	"./prism-elixir.js": [
		68805,
		68805
	],
	"./prism-elixir.min": [
		43045,
		43045
	],
	"./prism-elixir.min.js": [
		43045,
		43045
	],
	"./prism-elm": [
		75041,
		75041
	],
	"./prism-elm.js": [
		75041,
		75041
	],
	"./prism-elm.min": [
		84269,
		84269
	],
	"./prism-elm.min.js": [
		84269,
		84269
	],
	"./prism-erb": [
		66512,
		66512
	],
	"./prism-erb.js": [
		66512,
		66512
	],
	"./prism-erb.min": [
		83000,
		83000
	],
	"./prism-erb.min.js": [
		83000,
		83000
	],
	"./prism-erlang": [
		8956,
		8956
	],
	"./prism-erlang.js": [
		8956,
		8956
	],
	"./prism-erlang.min": [
		39540,
		39540
	],
	"./prism-erlang.min.js": [
		39540,
		39540
	],
	"./prism-etlua": [
		79958,
		79958
	],
	"./prism-etlua.js": [
		79958,
		79958
	],
	"./prism-etlua.min": [
		16195,
		16195
	],
	"./prism-etlua.min.js": [
		16195,
		16195
	],
	"./prism-excel-formula": [
		51039,
		51039
	],
	"./prism-excel-formula.js": [
		51039,
		51039
	],
	"./prism-excel-formula.min": [
		78876,
		78876
	],
	"./prism-excel-formula.min.js": [
		78876,
		78876
	],
	"./prism-factor": [
		50171,
		50171
	],
	"./prism-factor.js": [
		50171,
		50171
	],
	"./prism-factor.min": [
		16302,
		16302
	],
	"./prism-factor.min.js": [
		16302,
		16302
	],
	"./prism-false": [
		10427,
		10427
	],
	"./prism-false.js": [
		10427,
		10427
	],
	"./prism-false.min": [
		61259,
		61259
	],
	"./prism-false.min.js": [
		61259,
		61259
	],
	"./prism-firestore-security-rules": [
		6634,
		6634
	],
	"./prism-firestore-security-rules.js": [
		6634,
		6634
	],
	"./prism-firestore-security-rules.min": [
		67128,
		67128
	],
	"./prism-firestore-security-rules.min.js": [
		67128,
		67128
	],
	"./prism-flow": [
		9220,
		9220
	],
	"./prism-flow.js": [
		9220,
		9220
	],
	"./prism-flow.min": [
		96017,
		96017
	],
	"./prism-flow.min.js": [
		96017,
		96017
	],
	"./prism-fortran": [
		27915,
		27915
	],
	"./prism-fortran.js": [
		27915,
		27915
	],
	"./prism-fortran.min": [
		70975,
		70975
	],
	"./prism-fortran.min.js": [
		70975,
		70975
	],
	"./prism-fsharp": [
		75045,
		75045
	],
	"./prism-fsharp.js": [
		75045,
		75045
	],
	"./prism-fsharp.min": [
		25001,
		25001
	],
	"./prism-fsharp.min.js": [
		25001,
		25001
	],
	"./prism-ftl": [
		72778,
		72778
	],
	"./prism-ftl.js": [
		72778,
		72778
	],
	"./prism-ftl.min": [
		76831,
		76831
	],
	"./prism-ftl.min.js": [
		76831,
		76831
	],
	"./prism-gap": [
		91709,
		91709
	],
	"./prism-gap.js": [
		91709,
		91709
	],
	"./prism-gap.min": [
		40327,
		40327
	],
	"./prism-gap.min.js": [
		40327,
		40327
	],
	"./prism-gcode": [
		28407,
		28407
	],
	"./prism-gcode.js": [
		28407,
		28407
	],
	"./prism-gcode.min": [
		9303,
		9303
	],
	"./prism-gcode.min.js": [
		9303,
		9303
	],
	"./prism-gdscript": [
		65276,
		65276
	],
	"./prism-gdscript.js": [
		65276,
		65276
	],
	"./prism-gdscript.min": [
		20563,
		20563
	],
	"./prism-gdscript.min.js": [
		20563,
		20563
	],
	"./prism-gedcom": [
		66857,
		66857
	],
	"./prism-gedcom.js": [
		66857,
		66857
	],
	"./prism-gedcom.min": [
		17065,
		17065
	],
	"./prism-gedcom.min.js": [
		17065,
		17065
	],
	"./prism-gettext": [
		51315,
		51315
	],
	"./prism-gettext.js": [
		51315,
		51315
	],
	"./prism-gettext.min": [
		92082,
		92082
	],
	"./prism-gettext.min.js": [
		92082,
		92082
	],
	"./prism-gherkin": [
		49472,
		49472
	],
	"./prism-gherkin.js": [
		49472,
		49472
	],
	"./prism-gherkin.min": [
		19876,
		19876
	],
	"./prism-gherkin.min.js": [
		19876,
		19876
	],
	"./prism-git": [
		79787,
		79787
	],
	"./prism-git.js": [
		79787,
		79787
	],
	"./prism-git.min": [
		93530,
		93530
	],
	"./prism-git.min.js": [
		93530,
		93530
	],
	"./prism-glsl": [
		79812,
		79812
	],
	"./prism-glsl.js": [
		79812,
		79812
	],
	"./prism-glsl.min": [
		58575,
		58575
	],
	"./prism-glsl.min.js": [
		58575,
		58575
	],
	"./prism-gml": [
		71828,
		71828
	],
	"./prism-gml.js": [
		71828,
		71828
	],
	"./prism-gml.min": [
		81813,
		81813
	],
	"./prism-gml.min.js": [
		81813,
		81813
	],
	"./prism-gn": [
		1415,
		1415
	],
	"./prism-gn.js": [
		1415,
		1415
	],
	"./prism-gn.min": [
		7850,
		7850
	],
	"./prism-gn.min.js": [
		7850,
		7850
	],
	"./prism-go": [
		27046,
		27046
	],
	"./prism-go-module": [
		77346,
		77346
	],
	"./prism-go-module.js": [
		77346,
		77346
	],
	"./prism-go-module.min": [
		59109,
		59109
	],
	"./prism-go-module.min.js": [
		59109,
		59109
	],
	"./prism-go.js": [
		27046,
		27046
	],
	"./prism-go.min": [
		50677,
		50677
	],
	"./prism-go.min.js": [
		50677,
		50677
	],
	"./prism-gradle": [
		31565,
		31565
	],
	"./prism-gradle.js": [
		31565,
		31565
	],
	"./prism-gradle.min": [
		9662,
		9662
	],
	"./prism-gradle.min.js": [
		9662,
		9662
	],
	"./prism-graphql": [
		17117,
		17117
	],
	"./prism-graphql.js": [
		17117,
		17117
	],
	"./prism-graphql.min": [
		11530,
		11530
	],
	"./prism-graphql.min.js": [
		11530,
		11530
	],
	"./prism-groovy": [
		40485,
		40485
	],
	"./prism-groovy.js": [
		40485,
		40485
	],
	"./prism-groovy.min": [
		29627,
		29627
	],
	"./prism-groovy.min.js": [
		29627,
		29627
	],
	"./prism-haml": [
		39181,
		39181
	],
	"./prism-haml.js": [
		39181,
		39181
	],
	"./prism-haml.min": [
		53025,
		53025
	],
	"./prism-haml.min.js": [
		53025,
		53025
	],
	"./prism-handlebars": [
		70110,
		70110
	],
	"./prism-handlebars.js": [
		70110,
		70110
	],
	"./prism-handlebars.min": [
		34329,
		34329
	],
	"./prism-handlebars.min.js": [
		34329,
		34329
	],
	"./prism-haskell": [
		81295,
		81295
	],
	"./prism-haskell.js": [
		81295,
		81295
	],
	"./prism-haskell.min": [
		12199,
		12199
	],
	"./prism-haskell.min.js": [
		12199,
		12199
	],
	"./prism-haxe": [
		14324,
		14324
	],
	"./prism-haxe.js": [
		14324,
		14324
	],
	"./prism-haxe.min": [
		40714,
		40714
	],
	"./prism-haxe.min.js": [
		40714,
		40714
	],
	"./prism-hcl": [
		24677,
		24677
	],
	"./prism-hcl.js": [
		24677,
		24677
	],
	"./prism-hcl.min": [
		7044,
		7044
	],
	"./prism-hcl.min.js": [
		7044,
		7044
	],
	"./prism-hlsl": [
		5578,
		5578
	],
	"./prism-hlsl.js": [
		5578,
		5578
	],
	"./prism-hlsl.min": [
		62058,
		62058
	],
	"./prism-hlsl.min.js": [
		62058,
		62058
	],
	"./prism-hoon": [
		88161,
		88161
	],
	"./prism-hoon.js": [
		88161,
		88161
	],
	"./prism-hoon.min": [
		91246,
		91246
	],
	"./prism-hoon.min.js": [
		91246,
		91246
	],
	"./prism-hpkp": [
		26203,
		26203
	],
	"./prism-hpkp.js": [
		26203,
		26203
	],
	"./prism-hpkp.min": [
		67623,
		67623
	],
	"./prism-hpkp.min.js": [
		67623,
		67623
	],
	"./prism-hsts": [
		17786,
		17786
	],
	"./prism-hsts.js": [
		17786,
		17786
	],
	"./prism-hsts.min": [
		23808,
		23808
	],
	"./prism-hsts.min.js": [
		23808,
		23808
	],
	"./prism-http": [
		50057,
		50057
	],
	"./prism-http.js": [
		50057,
		50057
	],
	"./prism-http.min": [
		587,
		587
	],
	"./prism-http.min.js": [
		587,
		587
	],
	"./prism-ichigojam": [
		77460,
		77460
	],
	"./prism-ichigojam.js": [
		77460,
		77460
	],
	"./prism-ichigojam.min": [
		54111,
		54111
	],
	"./prism-ichigojam.min.js": [
		54111,
		54111
	],
	"./prism-icon": [
		54263,
		54263
	],
	"./prism-icon.js": [
		54263,
		54263
	],
	"./prism-icon.min": [
		45477,
		45477
	],
	"./prism-icon.min.js": [
		45477,
		45477
	],
	"./prism-icu-message-format": [
		90175,
		90175
	],
	"./prism-icu-message-format.js": [
		90175,
		90175
	],
	"./prism-icu-message-format.min": [
		48209,
		48209
	],
	"./prism-icu-message-format.min.js": [
		48209,
		48209
	],
	"./prism-idris": [
		16150,
		16150
	],
	"./prism-idris.js": [
		16150,
		16150
	],
	"./prism-idris.min": [
		75649,
		75649
	],
	"./prism-idris.min.js": [
		75649,
		75649
	],
	"./prism-iecst": [
		55689,
		55689
	],
	"./prism-iecst.js": [
		55689,
		55689
	],
	"./prism-iecst.min": [
		17238,
		17238
	],
	"./prism-iecst.min.js": [
		17238,
		17238
	],
	"./prism-ignore": [
		10880,
		10880
	],
	"./prism-ignore.js": [
		10880,
		10880
	],
	"./prism-ignore.min": [
		47122,
		47122
	],
	"./prism-ignore.min.js": [
		47122,
		47122
	],
	"./prism-inform7": [
		56521,
		56521
	],
	"./prism-inform7.js": [
		56521,
		56521
	],
	"./prism-inform7.min": [
		26293,
		26293
	],
	"./prism-inform7.min.js": [
		26293,
		26293
	],
	"./prism-ini": [
		29525,
		29525
	],
	"./prism-ini.js": [
		29525,
		29525
	],
	"./prism-ini.min": [
		19475,
		19475
	],
	"./prism-ini.min.js": [
		19475,
		19475
	],
	"./prism-io": [
		48942,
		48942
	],
	"./prism-io.js": [
		48942,
		48942
	],
	"./prism-io.min": [
		93154,
		93154
	],
	"./prism-io.min.js": [
		93154,
		93154
	],
	"./prism-j": [
		18848,
		18848
	],
	"./prism-j.js": [
		18848,
		18848
	],
	"./prism-j.min": [
		78067,
		78067
	],
	"./prism-j.min.js": [
		78067,
		78067
	],
	"./prism-java": [
		52503,
		52503
	],
	"./prism-java.js": [
		52503,
		52503
	],
	"./prism-java.min": [
		17706,
		17706
	],
	"./prism-java.min.js": [
		17706,
		17706
	],
	"./prism-javadoc": [
		52008,
		52008
	],
	"./prism-javadoc.js": [
		52008,
		52008
	],
	"./prism-javadoc.min": [
		78792,
		78792
	],
	"./prism-javadoc.min.js": [
		78792,
		78792
	],
	"./prism-javadoclike": [
		54884,
		54884
	],
	"./prism-javadoclike.js": [
		54884,
		54884
	],
	"./prism-javadoclike.min": [
		97854,
		97854
	],
	"./prism-javadoclike.min.js": [
		97854,
		97854
	],
	"./prism-javascript": [
		39980,
		39980
	],
	"./prism-javascript.js": [
		39980,
		39980
	],
	"./prism-javascript.min": [
		30235,
		30235
	],
	"./prism-javascript.min.js": [
		30235,
		30235
	],
	"./prism-javastacktrace": [
		81454,
		81454
	],
	"./prism-javastacktrace.js": [
		81454,
		81454
	],
	"./prism-javastacktrace.min": [
		39837,
		39837
	],
	"./prism-javastacktrace.min.js": [
		39837,
		39837
	],
	"./prism-jexl": [
		55314,
		55314
	],
	"./prism-jexl.js": [
		55314,
		55314
	],
	"./prism-jexl.min": [
		66116,
		66116
	],
	"./prism-jexl.min.js": [
		66116,
		66116
	],
	"./prism-jolie": [
		68874,
		68874
	],
	"./prism-jolie.js": [
		68874,
		68874
	],
	"./prism-jolie.min": [
		91429,
		91429
	],
	"./prism-jolie.min.js": [
		91429,
		91429
	],
	"./prism-jq": [
		96342,
		96342
	],
	"./prism-jq.js": [
		96342,
		96342
	],
	"./prism-jq.min": [
		92771,
		92771
	],
	"./prism-jq.min.js": [
		92771,
		92771
	],
	"./prism-js-extras": [
		46690,
		46690
	],
	"./prism-js-extras.js": [
		46690,
		46690
	],
	"./prism-js-extras.min": [
		49273,
		49273
	],
	"./prism-js-extras.min.js": [
		49273,
		49273
	],
	"./prism-js-templates": [
		38885,
		38885
	],
	"./prism-js-templates.js": [
		38885,
		38885
	],
	"./prism-js-templates.min": [
		3908,
		3908
	],
	"./prism-js-templates.min.js": [
		3908,
		3908
	],
	"./prism-jsdoc": [
		68915,
		68915
	],
	"./prism-jsdoc.js": [
		68915,
		68915
	],
	"./prism-jsdoc.min": [
		27472,
		27472
	],
	"./prism-jsdoc.min.js": [
		27472,
		27472
	],
	"./prism-json": [
		74277,
		74277
	],
	"./prism-json.js": [
		74277,
		74277
	],
	"./prism-json.min": [
		8674,
		8674
	],
	"./prism-json.min.js": [
		8674,
		8674
	],
	"./prism-json5": [
		22444,
		22444
	],
	"./prism-json5.js": [
		22444,
		22444
	],
	"./prism-json5.min": [
		54001,
		54001
	],
	"./prism-json5.min.js": [
		54001,
		54001
	],
	"./prism-jsonp": [
		64488,
		64488
	],
	"./prism-jsonp.js": [
		64488,
		64488
	],
	"./prism-jsonp.min": [
		81286,
		81286
	],
	"./prism-jsonp.min.js": [
		81286,
		81286
	],
	"./prism-jsstacktrace": [
		81917,
		81917
	],
	"./prism-jsstacktrace.js": [
		81917,
		81917
	],
	"./prism-jsstacktrace.min": [
		68152,
		68152
	],
	"./prism-jsstacktrace.min.js": [
		68152,
		68152
	],
	"./prism-jsx": [
		62356,
		62356
	],
	"./prism-jsx.js": [
		62356,
		62356
	],
	"./prism-jsx.min": [
		81233,
		81233
	],
	"./prism-jsx.min.js": [
		81233,
		81233
	],
	"./prism-julia": [
		56543,
		56543
	],
	"./prism-julia.js": [
		56543,
		56543
	],
	"./prism-julia.min": [
		82580,
		82580
	],
	"./prism-julia.min.js": [
		82580,
		82580
	],
	"./prism-keepalived": [
		71643,
		71643
	],
	"./prism-keepalived.js": [
		71643,
		71643
	],
	"./prism-keepalived.min": [
		25767,
		25767
	],
	"./prism-keepalived.min.js": [
		25767,
		25767
	],
	"./prism-keyman": [
		82821,
		82821
	],
	"./prism-keyman.js": [
		82821,
		82821
	],
	"./prism-keyman.min": [
		51064,
		51064
	],
	"./prism-keyman.min.js": [
		51064,
		51064
	],
	"./prism-kotlin": [
		32334,
		32334
	],
	"./prism-kotlin.js": [
		32334,
		32334
	],
	"./prism-kotlin.min": [
		44002,
		44002
	],
	"./prism-kotlin.min.js": [
		44002,
		44002
	],
	"./prism-kumir": [
		69486,
		69486
	],
	"./prism-kumir.js": [
		69486,
		69486
	],
	"./prism-kumir.min": [
		85389,
		85389
	],
	"./prism-kumir.min.js": [
		85389,
		85389
	],
	"./prism-kusto": [
		31634,
		31634
	],
	"./prism-kusto.js": [
		31634,
		31634
	],
	"./prism-kusto.min": [
		28368,
		28368
	],
	"./prism-kusto.min.js": [
		28368,
		28368
	],
	"./prism-latex": [
		90319,
		90319
	],
	"./prism-latex.js": [
		90319,
		90319
	],
	"./prism-latex.min": [
		99119,
		99119
	],
	"./prism-latex.min.js": [
		99119,
		99119
	],
	"./prism-latte": [
		87442,
		87442
	],
	"./prism-latte.js": [
		87442,
		87442
	],
	"./prism-latte.min": [
		29908,
		29908
	],
	"./prism-latte.min.js": [
		29908,
		29908
	],
	"./prism-less": [
		37802,
		37802
	],
	"./prism-less.js": [
		37802,
		37802
	],
	"./prism-less.min": [
		64006,
		64006
	],
	"./prism-less.min.js": [
		64006,
		64006
	],
	"./prism-lilypond": [
		61719,
		61719
	],
	"./prism-lilypond.js": [
		61719,
		61719
	],
	"./prism-lilypond.min": [
		12555,
		12555
	],
	"./prism-lilypond.min.js": [
		12555,
		12555
	],
	"./prism-linker-script": [
		47362,
		47362
	],
	"./prism-linker-script.js": [
		47362,
		47362
	],
	"./prism-linker-script.min": [
		25731,
		25731
	],
	"./prism-linker-script.min.js": [
		25731,
		25731
	],
	"./prism-liquid": [
		150,
		150
	],
	"./prism-liquid.js": [
		150,
		150
	],
	"./prism-liquid.min": [
		55728,
		55728
	],
	"./prism-liquid.min.js": [
		55728,
		55728
	],
	"./prism-lisp": [
		45520,
		45520
	],
	"./prism-lisp.js": [
		45520,
		45520
	],
	"./prism-lisp.min": [
		87770,
		87770
	],
	"./prism-lisp.min.js": [
		87770,
		87770
	],
	"./prism-livescript": [
		76347,
		76347
	],
	"./prism-livescript.js": [
		76347,
		76347
	],
	"./prism-livescript.min": [
		41163,
		41163
	],
	"./prism-livescript.min.js": [
		41163,
		41163
	],
	"./prism-llvm": [
		85153,
		85153
	],
	"./prism-llvm.js": [
		85153,
		85153
	],
	"./prism-llvm.min": [
		82932,
		82932
	],
	"./prism-llvm.min.js": [
		82932,
		82932
	],
	"./prism-log": [
		93335,
		93335
	],
	"./prism-log.js": [
		93335,
		93335
	],
	"./prism-log.min": [
		61762,
		61762
	],
	"./prism-log.min.js": [
		61762,
		61762
	],
	"./prism-lolcode": [
		26555,
		26555
	],
	"./prism-lolcode.js": [
		26555,
		26555
	],
	"./prism-lolcode.min": [
		10076,
		10076
	],
	"./prism-lolcode.min.js": [
		10076,
		10076
	],
	"./prism-lua": [
		66841,
		66841
	],
	"./prism-lua.js": [
		66841,
		66841
	],
	"./prism-lua.min": [
		63047,
		63047
	],
	"./prism-lua.min.js": [
		63047,
		63047
	],
	"./prism-magma": [
		6004,
		6004
	],
	"./prism-magma.js": [
		6004,
		6004
	],
	"./prism-magma.min": [
		27788,
		27788
	],
	"./prism-magma.min.js": [
		27788,
		27788
	],
	"./prism-makefile": [
		48443,
		48443
	],
	"./prism-makefile.js": [
		48443,
		48443
	],
	"./prism-makefile.min": [
		75151,
		75151
	],
	"./prism-makefile.min.js": [
		75151,
		75151
	],
	"./prism-markdown": [
		24064,
		24064
	],
	"./prism-markdown.js": [
		24064,
		24064
	],
	"./prism-markdown.min": [
		90047,
		90047
	],
	"./prism-markdown.min.js": [
		90047,
		90047
	],
	"./prism-markup": [
		24335,
		24335
	],
	"./prism-markup-templating": [
		96854,
		96854
	],
	"./prism-markup-templating.js": [
		96854,
		96854
	],
	"./prism-markup-templating.min": [
		48929,
		48929
	],
	"./prism-markup-templating.min.js": [
		48929,
		48929
	],
	"./prism-markup.js": [
		24335,
		24335
	],
	"./prism-markup.min": [
		74060,
		74060
	],
	"./prism-markup.min.js": [
		74060,
		74060
	],
	"./prism-mata": [
		86268,
		86268
	],
	"./prism-mata.js": [
		86268,
		86268
	],
	"./prism-mata.min": [
		50965,
		50965
	],
	"./prism-mata.min.js": [
		50965,
		50965
	],
	"./prism-matlab": [
		61169,
		61169
	],
	"./prism-matlab.js": [
		61169,
		61169
	],
	"./prism-matlab.min": [
		55354,
		55354
	],
	"./prism-matlab.min.js": [
		55354,
		55354
	],
	"./prism-maxscript": [
		33965,
		33965
	],
	"./prism-maxscript.js": [
		33965,
		33965
	],
	"./prism-maxscript.min": [
		69507,
		69507
	],
	"./prism-maxscript.min.js": [
		69507,
		69507
	],
	"./prism-mel": [
		16185,
		16185
	],
	"./prism-mel.js": [
		16185,
		16185
	],
	"./prism-mel.min": [
		52357,
		52357
	],
	"./prism-mel.min.js": [
		52357,
		52357
	],
	"./prism-mermaid": [
		23099,
		23099
	],
	"./prism-mermaid.js": [
		23099,
		23099
	],
	"./prism-mermaid.min": [
		9509,
		9509
	],
	"./prism-mermaid.min.js": [
		9509,
		9509
	],
	"./prism-metafont": [
		16554,
		16554
	],
	"./prism-metafont.js": [
		16554,
		16554
	],
	"./prism-metafont.min": [
		93340,
		93340
	],
	"./prism-metafont.min.js": [
		93340,
		93340
	],
	"./prism-mizar": [
		15101,
		15101
	],
	"./prism-mizar.js": [
		15101,
		15101
	],
	"./prism-mizar.min": [
		79310,
		79310
	],
	"./prism-mizar.min.js": [
		79310,
		79310
	],
	"./prism-mongodb": [
		89134,
		89134
	],
	"./prism-mongodb.js": [
		89134,
		89134
	],
	"./prism-mongodb.min": [
		85584,
		85584
	],
	"./prism-mongodb.min.js": [
		85584,
		85584
	],
	"./prism-monkey": [
		62468,
		80676
	],
	"./prism-monkey.js": [
		62468,
		80676
	],
	"./prism-monkey.min": [
		7259,
		7259
	],
	"./prism-monkey.min.js": [
		7259,
		7259
	],
	"./prism-moonscript": [
		61899,
		61899
	],
	"./prism-moonscript.js": [
		61899,
		61899
	],
	"./prism-moonscript.min": [
		65298,
		65298
	],
	"./prism-moonscript.min.js": [
		65298,
		65298
	],
	"./prism-n1ql": [
		55949,
		55949
	],
	"./prism-n1ql.js": [
		55949,
		55949
	],
	"./prism-n1ql.min": [
		86985,
		86985
	],
	"./prism-n1ql.min.js": [
		86985,
		86985
	],
	"./prism-n4js": [
		88651,
		88651
	],
	"./prism-n4js.js": [
		88651,
		88651
	],
	"./prism-n4js.min": [
		50169,
		50169
	],
	"./prism-n4js.min.js": [
		50169,
		50169
	],
	"./prism-nand2tetris-hdl": [
		80454,
		80454
	],
	"./prism-nand2tetris-hdl.js": [
		80454,
		80454
	],
	"./prism-nand2tetris-hdl.min": [
		48974,
		48974
	],
	"./prism-nand2tetris-hdl.min.js": [
		48974,
		48974
	],
	"./prism-naniscript": [
		17898,
		17898
	],
	"./prism-naniscript.js": [
		17898,
		17898
	],
	"./prism-naniscript.min": [
		42743,
		42743
	],
	"./prism-naniscript.min.js": [
		42743,
		42743
	],
	"./prism-nasm": [
		52353,
		52353
	],
	"./prism-nasm.js": [
		52353,
		52353
	],
	"./prism-nasm.min": [
		10603,
		10603
	],
	"./prism-nasm.min.js": [
		10603,
		10603
	],
	"./prism-neon": [
		77661,
		77661
	],
	"./prism-neon.js": [
		77661,
		77661
	],
	"./prism-neon.min": [
		98832,
		98832
	],
	"./prism-neon.min.js": [
		98832,
		98832
	],
	"./prism-nevod": [
		677,
		677
	],
	"./prism-nevod.js": [
		677,
		677
	],
	"./prism-nevod.min": [
		89444,
		89444
	],
	"./prism-nevod.min.js": [
		89444,
		89444
	],
	"./prism-nginx": [
		33436,
		33436
	],
	"./prism-nginx.js": [
		33436,
		33436
	],
	"./prism-nginx.min": [
		49503,
		49503
	],
	"./prism-nginx.min.js": [
		49503,
		49503
	],
	"./prism-nim": [
		35743,
		35743
	],
	"./prism-nim.js": [
		35743,
		35743
	],
	"./prism-nim.min": [
		61663,
		61663
	],
	"./prism-nim.min.js": [
		61663,
		61663
	],
	"./prism-nix": [
		58704,
		58704
	],
	"./prism-nix.js": [
		58704,
		58704
	],
	"./prism-nix.min": [
		34232,
		34232
	],
	"./prism-nix.min.js": [
		34232,
		34232
	],
	"./prism-nsis": [
		74876,
		74876
	],
	"./prism-nsis.js": [
		74876,
		74876
	],
	"./prism-nsis.min": [
		68617,
		68617
	],
	"./prism-nsis.min.js": [
		68617,
		68617
	],
	"./prism-objectivec": [
		11426,
		11426
	],
	"./prism-objectivec.js": [
		11426,
		11426
	],
	"./prism-objectivec.min": [
		51637,
		51637
	],
	"./prism-objectivec.min.js": [
		51637,
		51637
	],
	"./prism-ocaml": [
		24371,
		24371
	],
	"./prism-ocaml.js": [
		24371,
		24371
	],
	"./prism-ocaml.min": [
		37610,
		37610
	],
	"./prism-ocaml.min.js": [
		37610,
		37610
	],
	"./prism-odin": [
		35577,
		35577
	],
	"./prism-odin.js": [
		35577,
		35577
	],
	"./prism-odin.min": [
		15415,
		15415
	],
	"./prism-odin.min.js": [
		15415,
		15415
	],
	"./prism-opencl": [
		13144,
		13144
	],
	"./prism-opencl.js": [
		13144,
		13144
	],
	"./prism-opencl.min": [
		52818,
		52818
	],
	"./prism-opencl.min.js": [
		52818,
		52818
	],
	"./prism-openqasm": [
		85513,
		85513
	],
	"./prism-openqasm.js": [
		85513,
		85513
	],
	"./prism-openqasm.min": [
		19960,
		19960
	],
	"./prism-openqasm.min.js": [
		19960,
		19960
	],
	"./prism-oz": [
		903,
		903
	],
	"./prism-oz.js": [
		903,
		903
	],
	"./prism-oz.min": [
		87553,
		87553
	],
	"./prism-oz.min.js": [
		87553,
		87553
	],
	"./prism-parigp": [
		47511,
		47511
	],
	"./prism-parigp.js": [
		47511,
		47511
	],
	"./prism-parigp.min": [
		90575,
		90575
	],
	"./prism-parigp.min.js": [
		90575,
		90575
	],
	"./prism-parser": [
		40780,
		40780
	],
	"./prism-parser.js": [
		40780,
		40780
	],
	"./prism-parser.min": [
		97410,
		97410
	],
	"./prism-parser.min.js": [
		97410,
		97410
	],
	"./prism-pascal": [
		13210,
		13210
	],
	"./prism-pascal.js": [
		13210,
		13210
	],
	"./prism-pascal.min": [
		53484,
		53484
	],
	"./prism-pascal.min.js": [
		53484,
		53484
	],
	"./prism-pascaligo": [
		54332,
		54332
	],
	"./prism-pascaligo.js": [
		54332,
		54332
	],
	"./prism-pascaligo.min": [
		68000,
		68000
	],
	"./prism-pascaligo.min.js": [
		68000,
		68000
	],
	"./prism-pcaxis": [
		52892,
		52892
	],
	"./prism-pcaxis.js": [
		52892,
		52892
	],
	"./prism-pcaxis.min": [
		55863,
		55863
	],
	"./prism-pcaxis.min.js": [
		55863,
		55863
	],
	"./prism-peoplecode": [
		74984,
		74984
	],
	"./prism-peoplecode.js": [
		74984,
		74984
	],
	"./prism-peoplecode.min": [
		11025,
		11025
	],
	"./prism-peoplecode.min.js": [
		11025,
		11025
	],
	"./prism-perl": [
		20288,
		20288
	],
	"./prism-perl.js": [
		20288,
		20288
	],
	"./prism-perl.min": [
		93972,
		93972
	],
	"./prism-perl.min.js": [
		93972,
		93972
	],
	"./prism-php": [
		99945,
		99945
	],
	"./prism-php-extras": [
		89425,
		89425
	],
	"./prism-php-extras.js": [
		89425,
		89425
	],
	"./prism-php-extras.min": [
		66200,
		66200
	],
	"./prism-php-extras.min.js": [
		66200,
		66200
	],
	"./prism-php.js": [
		99945,
		99945
	],
	"./prism-php.min": [
		37675,
		37675
	],
	"./prism-php.min.js": [
		37675,
		37675
	],
	"./prism-phpdoc": [
		26280,
		26280
	],
	"./prism-phpdoc.js": [
		26280,
		26280
	],
	"./prism-phpdoc.min": [
		49724,
		49724
	],
	"./prism-phpdoc.min.js": [
		49724,
		49724
	],
	"./prism-plant-uml": [
		79457,
		79457
	],
	"./prism-plant-uml.js": [
		79457,
		79457
	],
	"./prism-plant-uml.min": [
		68912,
		68912
	],
	"./prism-plant-uml.min.js": [
		68912,
		68912
	],
	"./prism-plsql": [
		92927,
		92927
	],
	"./prism-plsql.js": [
		92927,
		92927
	],
	"./prism-plsql.min": [
		93771,
		93771
	],
	"./prism-plsql.min.js": [
		93771,
		93771
	],
	"./prism-powerquery": [
		63887,
		63887
	],
	"./prism-powerquery.js": [
		63887,
		63887
	],
	"./prism-powerquery.min": [
		43171,
		43171
	],
	"./prism-powerquery.min.js": [
		43171,
		43171
	],
	"./prism-powershell": [
		86862,
		86862
	],
	"./prism-powershell.js": [
		86862,
		86862
	],
	"./prism-powershell.min": [
		77424,
		77424
	],
	"./prism-powershell.min.js": [
		77424,
		77424
	],
	"./prism-processing": [
		97353,
		97353
	],
	"./prism-processing.js": [
		97353,
		97353
	],
	"./prism-processing.min": [
		15759,
		15759
	],
	"./prism-processing.min.js": [
		15759,
		15759
	],
	"./prism-prolog": [
		43932,
		43932
	],
	"./prism-prolog.js": [
		43932,
		43932
	],
	"./prism-prolog.min": [
		32517,
		32517
	],
	"./prism-prolog.min.js": [
		32517,
		32517
	],
	"./prism-promql": [
		17929,
		17929
	],
	"./prism-promql.js": [
		17929,
		17929
	],
	"./prism-promql.min": [
		43355,
		43355
	],
	"./prism-promql.min.js": [
		43355,
		43355
	],
	"./prism-properties": [
		45820,
		45820
	],
	"./prism-properties.js": [
		45820,
		45820
	],
	"./prism-properties.min": [
		31623,
		31623
	],
	"./prism-properties.min.js": [
		31623,
		31623
	],
	"./prism-protobuf": [
		37345,
		37345
	],
	"./prism-protobuf.js": [
		37345,
		37345
	],
	"./prism-protobuf.min": [
		98250,
		98250
	],
	"./prism-protobuf.min.js": [
		98250,
		98250
	],
	"./prism-psl": [
		70942,
		70942
	],
	"./prism-psl.js": [
		70942,
		70942
	],
	"./prism-psl.min": [
		62546,
		62546
	],
	"./prism-psl.min.js": [
		62546,
		62546
	],
	"./prism-pug": [
		93381,
		93381
	],
	"./prism-pug.js": [
		93381,
		93381
	],
	"./prism-pug.min": [
		63138,
		63138
	],
	"./prism-pug.min.js": [
		63138,
		63138
	],
	"./prism-puppet": [
		24319,
		24319
	],
	"./prism-puppet.js": [
		24319,
		24319
	],
	"./prism-puppet.min": [
		25834,
		25834
	],
	"./prism-puppet.min.js": [
		25834,
		25834
	],
	"./prism-pure": [
		9753,
		9753
	],
	"./prism-pure.js": [
		9753,
		9753
	],
	"./prism-pure.min": [
		44697,
		44697
	],
	"./prism-pure.min.js": [
		44697,
		44697
	],
	"./prism-purebasic": [
		92168,
		92168
	],
	"./prism-purebasic.js": [
		92168,
		92168
	],
	"./prism-purebasic.min": [
		57562,
		57562
	],
	"./prism-purebasic.min.js": [
		57562,
		57562
	],
	"./prism-purescript": [
		89485,
		89485
	],
	"./prism-purescript.js": [
		89485,
		89485
	],
	"./prism-purescript.min": [
		18472,
		18472
	],
	"./prism-purescript.min.js": [
		18472,
		18472
	],
	"./prism-python": [
		80366,
		80366
	],
	"./prism-python.js": [
		80366,
		80366
	],
	"./prism-python.min": [
		29208,
		29208
	],
	"./prism-python.min.js": [
		29208,
		29208
	],
	"./prism-q": [
		82939,
		82939
	],
	"./prism-q.js": [
		82939,
		82939
	],
	"./prism-q.min": [
		32055,
		32055
	],
	"./prism-q.min.js": [
		32055,
		32055
	],
	"./prism-qml": [
		84891,
		84891
	],
	"./prism-qml.js": [
		84891,
		84891
	],
	"./prism-qml.min": [
		81124,
		81124
	],
	"./prism-qml.min.js": [
		81124,
		81124
	],
	"./prism-qore": [
		94933,
		94933
	],
	"./prism-qore.js": [
		94933,
		94933
	],
	"./prism-qore.min": [
		93661,
		93661
	],
	"./prism-qore.min.js": [
		93661,
		93661
	],
	"./prism-qsharp": [
		26896,
		26896
	],
	"./prism-qsharp.js": [
		26896,
		26896
	],
	"./prism-qsharp.min": [
		10453,
		10453
	],
	"./prism-qsharp.min.js": [
		10453,
		10453
	],
	"./prism-r": [
		54803,
		54803
	],
	"./prism-r.js": [
		54803,
		54803
	],
	"./prism-r.min": [
		41704,
		41704
	],
	"./prism-r.min.js": [
		41704,
		41704
	],
	"./prism-racket": [
		24540,
		24540
	],
	"./prism-racket.js": [
		24540,
		24540
	],
	"./prism-racket.min": [
		87382,
		87382
	],
	"./prism-racket.min.js": [
		87382,
		87382
	],
	"./prism-reason": [
		28439,
		28439
	],
	"./prism-reason.js": [
		28439,
		28439
	],
	"./prism-reason.min": [
		47788,
		47788
	],
	"./prism-reason.min.js": [
		47788,
		47788
	],
	"./prism-regex": [
		49299,
		49299
	],
	"./prism-regex.js": [
		49299,
		49299
	],
	"./prism-regex.min": [
		64297,
		64297
	],
	"./prism-regex.min.js": [
		64297,
		64297
	],
	"./prism-rego": [
		2040,
		2040
	],
	"./prism-rego.js": [
		2040,
		2040
	],
	"./prism-rego.min": [
		43149,
		43149
	],
	"./prism-rego.min.js": [
		43149,
		43149
	],
	"./prism-renpy": [
		38512,
		38512
	],
	"./prism-renpy.js": [
		38512,
		38512
	],
	"./prism-renpy.min": [
		68169,
		68169
	],
	"./prism-renpy.min.js": [
		68169,
		68169
	],
	"./prism-rescript": [
		50096,
		50096
	],
	"./prism-rescript.js": [
		50096,
		50096
	],
	"./prism-rescript.min": [
		89064,
		89064
	],
	"./prism-rescript.min.js": [
		89064,
		89064
	],
	"./prism-rest": [
		76577,
		76577
	],
	"./prism-rest.js": [
		76577,
		76577
	],
	"./prism-rest.min": [
		22369,
		22369
	],
	"./prism-rest.min.js": [
		22369,
		22369
	],
	"./prism-rip": [
		40998,
		40998
	],
	"./prism-rip.js": [
		40998,
		40998
	],
	"./prism-rip.min": [
		44538,
		44538
	],
	"./prism-rip.min.js": [
		44538,
		44538
	],
	"./prism-roboconf": [
		94840,
		94840
	],
	"./prism-roboconf.js": [
		94840,
		94840
	],
	"./prism-roboconf.min": [
		33134,
		33134
	],
	"./prism-roboconf.min.js": [
		33134,
		33134
	],
	"./prism-robotframework": [
		23449,
		23449
	],
	"./prism-robotframework.js": [
		23449,
		23449
	],
	"./prism-robotframework.min": [
		9611,
		9611
	],
	"./prism-robotframework.min.js": [
		9611,
		9611
	],
	"./prism-ruby": [
		59385,
		59385
	],
	"./prism-ruby.js": [
		59385,
		59385
	],
	"./prism-ruby.min": [
		38751,
		38751
	],
	"./prism-ruby.min.js": [
		38751,
		38751
	],
	"./prism-rust": [
		70767,
		70767
	],
	"./prism-rust.js": [
		70767,
		70767
	],
	"./prism-rust.min": [
		60983,
		60983
	],
	"./prism-rust.min.js": [
		60983,
		60983
	],
	"./prism-sas": [
		71384,
		71384
	],
	"./prism-sas.js": [
		71384,
		71384
	],
	"./prism-sas.min": [
		8920,
		8920
	],
	"./prism-sas.min.js": [
		8920,
		8920
	],
	"./prism-sass": [
		89865,
		89865
	],
	"./prism-sass.js": [
		89865,
		89865
	],
	"./prism-sass.min": [
		23683,
		23683
	],
	"./prism-sass.min.js": [
		23683,
		23683
	],
	"./prism-scala": [
		12886,
		12886
	],
	"./prism-scala.js": [
		12886,
		12886
	],
	"./prism-scala.min": [
		57239,
		57239
	],
	"./prism-scala.min.js": [
		57239,
		57239
	],
	"./prism-scheme": [
		51412,
		51412
	],
	"./prism-scheme.js": [
		51412,
		51412
	],
	"./prism-scheme.min": [
		25781,
		25781
	],
	"./prism-scheme.min.js": [
		25781,
		25781
	],
	"./prism-scss": [
		92447,
		92447
	],
	"./prism-scss.js": [
		92447,
		92447
	],
	"./prism-scss.min": [
		9578,
		9578
	],
	"./prism-scss.min.js": [
		9578,
		9578
	],
	"./prism-shell-session": [
		42963,
		42963
	],
	"./prism-shell-session.js": [
		42963,
		42963
	],
	"./prism-shell-session.min": [
		98863,
		98863
	],
	"./prism-shell-session.min.js": [
		98863,
		98863
	],
	"./prism-smali": [
		10509,
		10509
	],
	"./prism-smali.js": [
		10509,
		10509
	],
	"./prism-smali.min": [
		51406,
		51406
	],
	"./prism-smali.min.js": [
		51406,
		51406
	],
	"./prism-smalltalk": [
		22738,
		22738
	],
	"./prism-smalltalk.js": [
		22738,
		22738
	],
	"./prism-smalltalk.min": [
		1122,
		1122
	],
	"./prism-smalltalk.min.js": [
		1122,
		1122
	],
	"./prism-smarty": [
		89281,
		89281
	],
	"./prism-smarty.js": [
		89281,
		89281
	],
	"./prism-smarty.min": [
		58794,
		58794
	],
	"./prism-smarty.min.js": [
		58794,
		58794
	],
	"./prism-sml": [
		9983,
		9983
	],
	"./prism-sml.js": [
		9983,
		9983
	],
	"./prism-sml.min": [
		60332,
		60332
	],
	"./prism-sml.min.js": [
		60332,
		60332
	],
	"./prism-solidity": [
		30893,
		30893
	],
	"./prism-solidity.js": [
		30893,
		30893
	],
	"./prism-solidity.min": [
		3648,
		3648
	],
	"./prism-solidity.min.js": [
		3648,
		3648
	],
	"./prism-solution-file": [
		37485,
		37485
	],
	"./prism-solution-file.js": [
		37485,
		37485
	],
	"./prism-solution-file.min": [
		44863,
		44863
	],
	"./prism-solution-file.min.js": [
		44863,
		44863
	],
	"./prism-soy": [
		84435,
		84435
	],
	"./prism-soy.js": [
		84435,
		84435
	],
	"./prism-soy.min": [
		95210,
		95210
	],
	"./prism-soy.min.js": [
		95210,
		95210
	],
	"./prism-sparql": [
		71327,
		71327
	],
	"./prism-sparql.js": [
		71327,
		71327
	],
	"./prism-sparql.min": [
		46811,
		46811
	],
	"./prism-sparql.min.js": [
		46811,
		46811
	],
	"./prism-splunk-spl": [
		612,
		612
	],
	"./prism-splunk-spl.js": [
		612,
		612
	],
	"./prism-splunk-spl.min": [
		34810,
		34810
	],
	"./prism-splunk-spl.min.js": [
		34810,
		34810
	],
	"./prism-sqf": [
		83113,
		83113
	],
	"./prism-sqf.js": [
		83113,
		83113
	],
	"./prism-sqf.min": [
		41970,
		41970
	],
	"./prism-sqf.min.js": [
		41970,
		41970
	],
	"./prism-sql": [
		35266,
		35266
	],
	"./prism-sql.js": [
		35266,
		35266
	],
	"./prism-sql.min": [
		82720,
		82720
	],
	"./prism-sql.min.js": [
		82720,
		82720
	],
	"./prism-squirrel": [
		34229,
		34229
	],
	"./prism-squirrel.js": [
		34229,
		34229
	],
	"./prism-squirrel.min": [
		84585,
		84585
	],
	"./prism-squirrel.min.js": [
		84585,
		84585
	],
	"./prism-stan": [
		65683,
		65683
	],
	"./prism-stan.js": [
		65683,
		65683
	],
	"./prism-stan.min": [
		54178,
		54178
	],
	"./prism-stan.min.js": [
		54178,
		54178
	],
	"./prism-stata": [
		12788,
		12788
	],
	"./prism-stata.js": [
		12788,
		12788
	],
	"./prism-stata.min": [
		83784,
		83784
	],
	"./prism-stata.min.js": [
		83784,
		83784
	],
	"./prism-stylus": [
		24906,
		24906
	],
	"./prism-stylus.js": [
		24906,
		24906
	],
	"./prism-stylus.min": [
		72660,
		72660
	],
	"./prism-stylus.min.js": [
		72660,
		72660
	],
	"./prism-supercollider": [
		8571,
		8571
	],
	"./prism-supercollider.js": [
		8571,
		8571
	],
	"./prism-supercollider.min": [
		97553,
		97553
	],
	"./prism-supercollider.min.js": [
		97553,
		97553
	],
	"./prism-swift": [
		90874,
		90874
	],
	"./prism-swift.js": [
		90874,
		90874
	],
	"./prism-swift.min": [
		39361,
		39361
	],
	"./prism-swift.min.js": [
		39361,
		39361
	],
	"./prism-systemd": [
		48598,
		48598
	],
	"./prism-systemd.js": [
		48598,
		48598
	],
	"./prism-systemd.min": [
		32384,
		32384
	],
	"./prism-systemd.min.js": [
		32384,
		32384
	],
	"./prism-t4-cs": [
		20601,
		20601
	],
	"./prism-t4-cs.js": [
		20601,
		20601
	],
	"./prism-t4-cs.min": [
		73233,
		73233
	],
	"./prism-t4-cs.min.js": [
		73233,
		73233
	],
	"./prism-t4-templating": [
		89239,
		89239
	],
	"./prism-t4-templating.js": [
		89239,
		89239
	],
	"./prism-t4-templating.min": [
		94413,
		94413
	],
	"./prism-t4-templating.min.js": [
		94413,
		94413
	],
	"./prism-t4-vb": [
		16241,
		16241
	],
	"./prism-t4-vb.js": [
		16241,
		16241
	],
	"./prism-t4-vb.min": [
		78305,
		78305
	],
	"./prism-t4-vb.min.js": [
		78305,
		78305
	],
	"./prism-tap": [
		46193,
		46193
	],
	"./prism-tap.js": [
		46193,
		46193
	],
	"./prism-tap.min": [
		85599,
		85599
	],
	"./prism-tap.min.js": [
		85599,
		85599
	],
	"./prism-tcl": [
		1607,
		1607
	],
	"./prism-tcl.js": [
		1607,
		1607
	],
	"./prism-tcl.min": [
		96195,
		96195
	],
	"./prism-tcl.min.js": [
		96195,
		96195
	],
	"./prism-textile": [
		60075,
		60075
	],
	"./prism-textile.js": [
		60075,
		60075
	],
	"./prism-textile.min": [
		34966,
		34966
	],
	"./prism-textile.min.js": [
		34966,
		34966
	],
	"./prism-toml": [
		9930,
		9930
	],
	"./prism-toml.js": [
		9930,
		9930
	],
	"./prism-toml.min": [
		30485,
		30485
	],
	"./prism-toml.min.js": [
		30485,
		30485
	],
	"./prism-tremor": [
		84315,
		84315
	],
	"./prism-tremor.js": [
		84315,
		84315
	],
	"./prism-tremor.min": [
		80367,
		80367
	],
	"./prism-tremor.min.js": [
		80367,
		80367
	],
	"./prism-tsx": [
		21029,
		21029
	],
	"./prism-tsx.js": [
		21029,
		21029
	],
	"./prism-tsx.min": [
		44833,
		44833
	],
	"./prism-tsx.min.js": [
		44833,
		44833
	],
	"./prism-tt2": [
		37838,
		37838
	],
	"./prism-tt2.js": [
		37838,
		37838
	],
	"./prism-tt2.min": [
		89366,
		89366
	],
	"./prism-tt2.min.js": [
		89366,
		89366
	],
	"./prism-turtle": [
		68092,
		68092
	],
	"./prism-turtle.js": [
		68092,
		68092
	],
	"./prism-turtle.min": [
		10034,
		10034
	],
	"./prism-turtle.min.js": [
		10034,
		10034
	],
	"./prism-twig": [
		71429,
		71429
	],
	"./prism-twig.js": [
		71429,
		71429
	],
	"./prism-twig.min": [
		33161,
		33161
	],
	"./prism-twig.min.js": [
		33161,
		33161
	],
	"./prism-typescript": [
		96836,
		96836
	],
	"./prism-typescript.js": [
		96836,
		96836
	],
	"./prism-typescript.min": [
		76456,
		76456
	],
	"./prism-typescript.min.js": [
		76456,
		76456
	],
	"./prism-typoscript": [
		14032,
		14032
	],
	"./prism-typoscript.js": [
		14032,
		14032
	],
	"./prism-typoscript.min": [
		42432,
		42432
	],
	"./prism-typoscript.min.js": [
		42432,
		42432
	],
	"./prism-unrealscript": [
		10196,
		10196
	],
	"./prism-unrealscript.js": [
		10196,
		10196
	],
	"./prism-unrealscript.min": [
		79133,
		79133
	],
	"./prism-unrealscript.min.js": [
		79133,
		79133
	],
	"./prism-uorazor": [
		52467,
		52467
	],
	"./prism-uorazor.js": [
		52467,
		52467
	],
	"./prism-uorazor.min": [
		6723,
		6723
	],
	"./prism-uorazor.min.js": [
		6723,
		6723
	],
	"./prism-uri": [
		65503,
		65503
	],
	"./prism-uri.js": [
		65503,
		65503
	],
	"./prism-uri.min": [
		24526,
		24526
	],
	"./prism-uri.min.js": [
		24526,
		24526
	],
	"./prism-v": [
		14641,
		14641
	],
	"./prism-v.js": [
		14641,
		14641
	],
	"./prism-v.min": [
		13384,
		13384
	],
	"./prism-v.min.js": [
		13384,
		13384
	],
	"./prism-vala": [
		30035,
		30035
	],
	"./prism-vala.js": [
		30035,
		30035
	],
	"./prism-vala.min": [
		67524,
		67524
	],
	"./prism-vala.min.js": [
		67524,
		67524
	],
	"./prism-vbnet": [
		65398,
		65398
	],
	"./prism-vbnet.js": [
		65398,
		65398
	],
	"./prism-vbnet.min": [
		89588,
		89588
	],
	"./prism-vbnet.min.js": [
		89588,
		89588
	],
	"./prism-velocity": [
		70981,
		70981
	],
	"./prism-velocity.js": [
		70981,
		70981
	],
	"./prism-velocity.min": [
		76627,
		76627
	],
	"./prism-velocity.min.js": [
		76627,
		76627
	],
	"./prism-verilog": [
		47251,
		47251
	],
	"./prism-verilog.js": [
		47251,
		47251
	],
	"./prism-verilog.min": [
		93937,
		93937
	],
	"./prism-verilog.min.js": [
		93937,
		93937
	],
	"./prism-vhdl": [
		38564,
		38564
	],
	"./prism-vhdl.js": [
		38564,
		38564
	],
	"./prism-vhdl.min": [
		377,
		377
	],
	"./prism-vhdl.min.js": [
		377,
		377
	],
	"./prism-vim": [
		34438,
		34438
	],
	"./prism-vim.js": [
		34438,
		34438
	],
	"./prism-vim.min": [
		34836,
		34836
	],
	"./prism-vim.min.js": [
		34836,
		34836
	],
	"./prism-visual-basic": [
		83082,
		83082
	],
	"./prism-visual-basic.js": [
		83082,
		83082
	],
	"./prism-visual-basic.min": [
		67964,
		67964
	],
	"./prism-visual-basic.min.js": [
		67964,
		67964
	],
	"./prism-warpscript": [
		10008,
		10008
	],
	"./prism-warpscript.js": [
		10008,
		10008
	],
	"./prism-warpscript.min": [
		80552,
		80552
	],
	"./prism-warpscript.min.js": [
		80552,
		80552
	],
	"./prism-wasm": [
		5774,
		5774
	],
	"./prism-wasm.js": [
		5774,
		5774
	],
	"./prism-wasm.min": [
		53994,
		53994
	],
	"./prism-wasm.min.js": [
		53994,
		53994
	],
	"./prism-web-idl": [
		64040,
		64040
	],
	"./prism-web-idl.js": [
		64040,
		64040
	],
	"./prism-web-idl.min": [
		42239,
		42239
	],
	"./prism-web-idl.min.js": [
		42239,
		42239
	],
	"./prism-wgsl": [
		10230,
		10230
	],
	"./prism-wgsl.js": [
		10230,
		10230
	],
	"./prism-wgsl.min": [
		58082,
		58082
	],
	"./prism-wgsl.min.js": [
		58082,
		58082
	],
	"./prism-wiki": [
		31693,
		31693
	],
	"./prism-wiki.js": [
		31693,
		31693
	],
	"./prism-wiki.min": [
		11589,
		11589
	],
	"./prism-wiki.min.js": [
		11589,
		11589
	],
	"./prism-wolfram": [
		99729,
		99729
	],
	"./prism-wolfram.js": [
		99729,
		99729
	],
	"./prism-wolfram.min": [
		18722,
		18722
	],
	"./prism-wolfram.min.js": [
		18722,
		18722
	],
	"./prism-wren": [
		45682,
		45682
	],
	"./prism-wren.js": [
		45682,
		45682
	],
	"./prism-wren.min": [
		30877,
		30877
	],
	"./prism-wren.min.js": [
		30877,
		30877
	],
	"./prism-xeora": [
		10504,
		10504
	],
	"./prism-xeora.js": [
		10504,
		10504
	],
	"./prism-xeora.min": [
		30646,
		30646
	],
	"./prism-xeora.min.js": [
		30646,
		30646
	],
	"./prism-xml-doc": [
		62349,
		62349
	],
	"./prism-xml-doc.js": [
		62349,
		62349
	],
	"./prism-xml-doc.min": [
		19883,
		19883
	],
	"./prism-xml-doc.min.js": [
		19883,
		19883
	],
	"./prism-xojo": [
		22449,
		22449
	],
	"./prism-xojo.js": [
		22449,
		22449
	],
	"./prism-xojo.min": [
		37315,
		37315
	],
	"./prism-xojo.min.js": [
		37315,
		37315
	],
	"./prism-xquery": [
		19938,
		19938
	],
	"./prism-xquery.js": [
		19938,
		19938
	],
	"./prism-xquery.min": [
		25558,
		25558
	],
	"./prism-xquery.min.js": [
		25558,
		25558
	],
	"./prism-yaml": [
		73358,
		73358
	],
	"./prism-yaml.js": [
		73358,
		73358
	],
	"./prism-yaml.min": [
		28831,
		28831
	],
	"./prism-yaml.min.js": [
		28831,
		28831
	],
	"./prism-yang": [
		2982,
		2982
	],
	"./prism-yang.js": [
		2982,
		2982
	],
	"./prism-yang.min": [
		6959,
		6959
	],
	"./prism-yang.min.js": [
		6959,
		6959
	],
	"./prism-zig": [
		857,
		857
	],
	"./prism-zig.js": [
		857,
		857
	],
	"./prism-zig.min": [
		87975,
		87975
	],
	"./prism-zig.min.js": [
		87975,
		87975
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 7 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 96316;
module.exports = webpackAsyncContext;

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [61608,19642,5135,93565,49774,92888,40179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);